const en = {
  // ── Menu / Sidebar ───────────────────────────────────────
  "menu.overview": "Overview",
  "menu.conversations": "Conversations",
  "menu.statistics": "Statistics",
  "menu.analytics": "Analytics",
  "menu.clicks": "Clicks",
  "menu.adPerformance": "Ad Performance",
  "menu.conversions": "Conversions",
  "menu.crm": "CRM",
  "menu.crmCustomers": "Customers",
  "menu.crmSales": "Sales",
  "menu.catalog": "Catalog",
  "menu.families": "Families",
  "menu.usosGrupos": "Uses & Groups",
  "menu.inventory": "Inventory",
  "menu.consumo": "Usage",
  "menu.mapa": "Map",
  "mapa.title": "Mexico map",
  "mapa.subtitle": "Distribution by state. Hover for details.",
  "mapa.ml": "ML",
  "mapa.ventas": "Sales",
  "mapa.conversations": "Conversations",
  "mapa.clicks": "Clicks",
  "mapa.p7": "7 days",
  "mapa.p30": "30 days",
  "mapa.p90": "90 days",
  "mapa.pall": "All",
  "mapa.hint": "Deeper color = higher volume. Coming soon: zoom in for municipalities.",
  "menu.payment": "Payment",
  "consumo.title": "Usage",
  "consumo.subtitle": "Conversations for {{month}}",
  "consumo.plan": "Plan",
  "consumo.perMonth": "{{n}} convos/mo",
  "consumo.today": "Today",
  "consumo.thisMonth": "This month",
  "consumo.remaining": "Remaining",
  "consumo.overage": "Overage",
  "consumo.rateTBD": "rate TBD",
  "consumo.byDay": "Conversations per day",
  "payment.due": "💳 Your monthly payment of {{price}} {{currency}} is due by the {{day}}th.",
  "payment.overdue": "⚠️ Payment overdue: your {{price}} {{currency}} plan was due before the {{day}}th. Please settle to avoid interruptions.",
  "menu.pos": "Points of Sale",
  "menu.campaigns": "Campaigns",
  "menu.campAdmin": "Administration",
  "menu.campAnalysis": "Analysis",
  "menu.campStrategy": "Strategy",
  "menu.campAgent": "Agent",
  "menu.campTools": "Tools",
  "menu.campaignsSub": "Campaigns",
  "menu.adSets": "Ad Sets",
  "menu.ads": "Ads",
  "menu.desempeno": "Performance",
  "menu.segmentacion": "Segmentation",
  "menu.spendOptimization": "Optimization",
  "menu.flujos": "Flow Structure",
  "menu.convoFlows": "Flows",
  "menu.forecast": "Forecast (Clicks)",
  "menu.simulador": "Sandbox",
  "menu.intelligence": "Artificial Intelligence",
  "menu.mlImport": "Import Orders",
  "menu.trackedLinks": "Tracked Links",
  "menu.flowPrompts": "Flow Prompts",
  "menu.users": "Users",
  "menu.usersSub": "Users",
  "menu.roles": "Roles",
  "menu.profiles": "Profiles",
  "menu.mercadoLibre": "Mercado Libre",
  "menu.orders": "Orders",
  "menu.importer": "Import to Inventory",
  "menu.bot": "Bot",
  "menu.intents": "Intents",
  "menu.aiUsage": "AI Costs",
  "menu.workflows": "Workflows (beta)",
  "menu.adWorkflow": "Workflow on ad",
  "menu.sandbox": "Sandbox",
  "menu.promos": "Promotions",
  "menu.playground": "Playground",
  "menu.playgroundML": "Mercado Libre",
  "menu.playgroundForecast": "Sales Forecast",
  "menu.playgroundSegments": "Segmentation",
  "menu.playgroundConversion": "Conversion Prob.",
  "menu.messagePerformance": "Message Performance",
  "menu.gcFollowUp": "Ground Cover Follow-up",
  "menu.playgroundSpend": "Spend Optimization",
  "menu.tickets": "Tickets",
  "menu.salesOverview": "Sales Overview",
  "menu.notifications": "Notifications",
  "menu.crossSell": "Cross-Selling",
  "menu.companyInfo": "Company Info",
  "menu.reportedConvos": "Reported Convos",
  "menu.settings": "Settings",
  "menu.specOps": "Spec Ops",
  "menu.killswitch": "Killswitch",
  "menu.nukeEm": "Nuke'em",
  "menu.liberado": "Liberado",
  "menu.banner": "Banner",
  "menu.fbCommentReply": "FB Comments",
  "menu.help": "Help",

  // ── Common ───────────────────────────────────────────────
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.add": "Add",
  "common.create": "Create",
  "common.close": "Close",
  "common.search": "Search",
  "common.loading": "Loading...",
  "common.actions": "Actions",
  "common.name": "Name",
  "common.description": "Description",
  "common.status": "Status",
  "common.type": "Type",
  "common.date": "Date",
  "common.active": "Active",
  "common.inactive": "Inactive",
  "common.yes": "Yes",
  "common.no": "No",
  "common.none": "None",
  "common.all": "All",
  "common.back": "Back",
  "common.next": "Next",
  "common.previous": "Previous",
  "common.confirm": "Confirm",
  "common.required": "Required",
  "common.optional": "Optional",
  "common.noData": "No data",
  "common.error": "Error",
  "common.success": "Success",
  "common.warning": "Warning",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.import": "Import",
  "common.export": "Export",
  "common.details": "Details",
  "common.select": "Select",
  "common.selectOption": "Select an option",
  "common.refresh": "Refresh",
  "common.processing": "Processing...",
  "common.saving": "Saving...",
  "common.deleting": "Deleting...",
  "common.noResults": "No results",
  "common.viewAll": "View all",
  "common.enable": "Enable",
  "common.disable": "Disable",
  "common.enabled": "Enabled",
  "common.disabled": "Disabled",
  "common.price": "Price",
  "common.total": "Total",
  "common.filter": "Filter",
  "common.clear": "Clear",
  "common.apply": "Apply",
  "common.download": "Download",
  "common.upload": "Upload",
  "common.preview": "Preview",
  "common.link": "Link",
  "common.image": "Image",
  "common.category": "Category",
  "common.subcategory": "Subcategory",
  "common.family": "Family",
  "common.subfamily": "Subfamily",
  "common.product": "Product",
  "common.products": "Products",
  "common.campaign": "Campaign",
  "common.adSet": "Ad Set",
  "common.ad": "Ad",
  "common.user": "User",
  "common.role": "Role",
  "common.profile": "Profile",
  "common.email": "Email",
  "common.password": "Password",
  "common.permissions": "Permissions",
  "common.createdAt": "Created at",
  "common.updatedAt": "Last updated",

  // ── App.js Header / Sidebar ──────────────────────────────
  "app.subtitle": "Monitor your chatbot in real time",
  "app.live": "Live",
  "app.logout": "Log Out",
  "app.admin": "Administrator",
  "app.updateAvailable": "A new version of the dashboard is available.",
  "app.updateButton": "Update",
  "app.loadingAuth": "Loading...",

  // ── Simulation Mode ──────────────────────────────────────
  "simulation.title": "Simulation Mode:",
  "simulation.viewingAs": "Viewing as",
  "simulation.allPermissions": "All permissions",
  "simulation.permissionsCount": "{{count}} permissions",
  "simulation.exit": "Exit",
  "simulation.selectRole": "Simulate role",
  "simulation.selectProfile": "Select profile",
  "simulation.start": "Start simulation",
  "simulation.stop": "Stop simulation",
  "simulation.viewing": "Simulation view",
  "simulation.realView": "Real view",

  // ── Overview / Dashboard ─────────────────────────────────
  "overview.todayStats": "Today's Statistics",
  "overview.totalMessages": "Total Messages",
  "overview.uniqueUsers": "Unique Chats",
  "overview.responseRate": "Response Rate",
  "overview.unanswered": "Unanswered",
  "overview.activeCampaigns": "Active Campaigns",
  "overview.topRegion": "Most active region",
  "overview.conversations": "conversations",
  "overview.activitySummary": "Activity Summary (Last 12 hours)",
  "overview.answered": "Answered",
  "overview.received": "Received",
  "overview.allMessages": "All Messages",
  "overview.usersOnly": "Users Only",
  "overview.botOnly": "Bot Only",
  "overview.recentConversations": "Recent Conversations - Last 10",
  "overview.loadingMessages": "Loading messages...",
  "overview.dateTime": "Date & Time",
  "overview.userId": "User ID",
  "overview.message": "Message",
  "overview.conversationDetail": "Conversation Detail",
  "overview.bot": "Bot",
  "overview.userLabel": "User",
  "overview.noMessages": "No messages",

  // ── Analytics ────────────────────────────────────────────
  "analytics.dailyMessages": "Today's messages",
  "analytics.activeCampaigns": "Active campaigns",
  "analytics.sales": "Sales",
  "analytics.mostClickedAd": "Most clicked ad",
  "analytics.clicks": "clicks",
  "analytics.ctr": "Click-through rate (CTR)",
  "analytics.bestConversionRate": "Best conversion rate",
  "analytics.salesCount": "sales",
  "analytics.bestSellingProduct": "Best selling product",

  // ── Delete Confirmations ─────────────────────────────────
  "delete.title": "Confirm Deletion",
  "delete.cannotUndo": "This action cannot be undone",
  "delete.confirmGeneric": "Are you sure you want to delete \"{{name}}\"?",
  "delete.confirmProduct": "Are you sure you want to delete {{name}}?",
  "delete.confirmCampaign": "Are you sure you want to delete the campaign {{name}}?",
  "delete.confirmItem": "Are you sure you want to delete {{name}}?",
  "delete.deleteProduct": "Delete Product",
  "delete.deleteCampaign": "Delete Campaign",
  "delete.deleteAdSet": "Delete Ad Set",
  "delete.deleteAd": "Delete Ad",
  "delete.deleteCampaignProduct": "Delete Campaign Product",
  "delete.deleteProductFamily": "Delete Product Family",
  "delete.deleteCatalogEntry": "Delete Catalog Entry",
  "delete.confirmProductFamily": "Are you sure you want to delete {{name}}? This will also delete all its children.",
  "delete.confirmCatalogEntry": "Are you sure you want to delete the entry {{name}} from the master catalog?",
  "delete.confirmCampaignProduct": "Are you sure you want to delete the product {{name}}?",
  "delete.cascadeCampaign": " This will also delete all associated ad sets and ads.",
  "delete.cascadeAdSet": " This will also delete all associated ads.",
  "delete.thisElement": "this element",
  "delete.confirmDelete": "Are you sure you want to delete",
  "delete.campaignLabel": "Campaign",
  "delete.adSetLabel": "Ad Set",
  "delete.adLabel": "Ad",
  "delete.cascadeChildren": "This will also delete all its children.",

  // ── Alert messages (from App.js handlers) ────────────────
  "alert.errorDeleteProduct": "Error deleting product",
  "alert.errorSaveProduct": "Error saving product",
  "alert.errorDeleteCampaign": "Error deleting campaign",
  "alert.savedSuccess": "Saved successfully! ad.summary: {{summary}}",
  "alert.errorSaveAdSet": "Error saving ad set: ",
  "alert.errorDeleteAdSet": "Error deleting ad set",
  "alert.errorSaveAd": "Error saving ad: ",
  "alert.errorDeleteAd": "Error deleting ad",
  "alert.errorDeleteCampaignProduct": "Error deleting campaign product",
  "alert.errorSaveCampaignProduct": "Error saving campaign product",
  "alert.errorDeleteCatalog": "Error deleting master catalog entry",
  "alert.errorSaveCatalog": "Error saving master catalog entry",
  "alert.errorDeleteUso": "Error deleting use",
  "alert.errorSaveUso": "Error saving use",
  "alert.errorDeleteGrupo": "Error deleting group",
  "alert.errorSaveGrupo": "Error saving group",
  "alert.errorDeletePOS": "Error deleting point of sale",
  "alert.errorSavePOS": "Error saving point of sale",
  "alert.errorDeleteProductFamily": "Error: Cannot delete product because the ID is not valid",
  "alert.errorCopyProduct": "Error copying product",
  "alert.confirmDeleteUso": "Are you sure you want to delete the use \"{{name}}\"?\n\nThis action cannot be undone.",
  "alert.confirmDeleteGrupo": "Are you sure you want to delete the group \"{{name}}\"?\n\nThis action cannot be undone.",
  "alert.confirmDeletePOS": "Are you sure you want to delete the point of sale \"{{name}}\"?\n\nThis action cannot be undone.",
  "alert.takeoverSuccess": "You took over · the bot will no longer reply to this conversation.",
  "alert.releaseSuccess": "Conversation released · the bot can respond again.",

  // ── Login ────────────────────────────────────────────────
  "login.title": "Hanlob Bot",
  "login.subtitle": "Admin Dashboard",
  "login.username": "Username",
  "login.password": "Password",
  "login.usernamePlaceholder": "Enter your username",
  "login.passwordPlaceholder": "Enter your password",
  "login.submit": "Log In",
  "login.loading": "Logging in...",
  "login.forgotPassword": "Forgot your password?",
  "login.defaultCredentials": "Default credentials:",
  "login.errorRequired": "Please enter username and password",
  "login.errorGeneric": "Login error",
  "login.welcome": "Welcome!",

  // ── Forgot Password ──────────────────────────────────────
  "forgot.title": "Recover password",
  "forgot.subtitle": "Enter your email and we'll send you a link to reset your password.",
  "forgot.emailLabel": "Email address",
  "forgot.emailPlaceholder": "you@email.com",
  "forgot.submit": "Send recovery link",
  "forgot.sending": "Sending...",
  "forgot.backToLogin": "Back to login",
  "forgot.errorRequired": "Please enter your email",
  "forgot.successToast": "Check your email",
  "forgot.checkEmail": "Check your email",
  "forgot.checkEmailSubtitle": "If an account exists with that email, you will receive a password reset link.",
  "forgot.sentTo": "We sent an email to",
  "forgot.linkExpires": "The link will expire in 1 hour. If you don't see it, check your spam folder.",

  // ── Reset Password ───────────────────────────────────────
  "reset.title": "New password",
  "reset.greeting": "Hi {{name}}, enter your new password.",
  "reset.newPassword": "New password",
  "reset.confirmPassword": "Confirm password",
  "reset.minChars": "Minimum 6 characters",
  "reset.repeatPassword": "Repeat your password",
  "reset.submit": "Reset password",
  "reset.updating": "Updating...",
  "reset.verifying": "Verifying link...",
  "reset.invalidLink": "Invalid link",
  "reset.invalidSubtitle": "This recovery link is invalid or has expired.",
  "reset.linkExpired": "Recovery links expire after 1 hour for security reasons.",
  "reset.requestNew": "Request new link",
  "reset.successTitle": "Password updated",
  "reset.successSubtitle": "Your password has been reset successfully.",
  "reset.goToLogin": "Log in",
  "reset.errorRequired": "Please fill in all fields",
  "reset.errorMismatch": "Passwords do not match",
  "reset.errorMinLength": "Password must be at least 6 characters",
  "reset.successToast": "Password updated successfully",
  "reset.errorGeneric": "Error resetting password",

  // ── Settings ─────────────────────────────────────────────
  "settings.title": "Settings",
  "settings.userInfo": "User Information",
  "settings.usernameLabel": "Username:",
  "settings.fullName": "Full name:",
  "settings.emailLabel": "Email:",
  "settings.roleLabel": "Role:",
  "settings.profileLabel": "Profile:",
  "settings.pushNotifications": "Push Notifications",
  "settings.pushNotSupported": "Your browser does not support push notifications.",
  "settings.pushDescription": "Receive alerts when a customer needs human help, even when you're not on the dashboard.",
  "settings.pushEnabled": "Notifications enabled",
  "settings.pushDisabled": "Notifications disabled",
  "settings.pushDenied": "Notification permission denied",
  "settings.pushErrorEnable": "Error enabling notifications",
  "settings.pushErrorDisable": "Error disabling notifications",
  "settings.changePassword": "Change Password",
  "settings.currentPassword": "Current Password",
  "settings.newPassword": "New Password",
  "settings.confirmNewPassword": "Confirm New Password",
  "settings.currentPasswordPlaceholder": "Enter your current password",
  "settings.newPasswordPlaceholder": "Minimum 6 characters",
  "settings.confirmPasswordPlaceholder": "Confirm your new password",
  "settings.changingPassword": "Changing password...",
  "settings.submitChangePassword": "Change Password",
  "settings.errorAllRequired": "All fields are required",
  "settings.errorMinLength": "New password must be at least 6 characters",
  "settings.errorMismatch": "Passwords do not match",
  "settings.passwordChanged": "Password changed successfully",
  "settings.errorChangePassword": "Error changing password",
  "settings.language": "Language",
  "settings.languageDescription": "Select the dashboard language.",

  // ── AuthContext ──────────────────────────────────────────
  "auth.serverError": "Error connecting to server",

  // ── Messages / Conversations ─────────────────────────────
  "messages.title": "Conversations",
  "messages.search": "Search by PSID or message...",
  "messages.noConversations": "No conversations",
  "messages.loadMore": "Load more",
  "messages.typeMessage": "Type a message...",
  "messages.send": "Send",
  "messages.takeover": "Take over",
  "messages.release": "Release",
  "messages.humanControlled": "Human control",
  "messages.botControlled": "Bot control",
  "messages.today": "Today",
  "messages.yesterday": "Yesterday",
  "messages.noMessages": "No messages in this conversation",
  "messages.handoverActive": "Human support active",
  "messages.handoverBy": "By: {{agent}}",
  "messages.handoverSince": "Since: {{date}}",
  "messages.returnToBot": "Return to bot",
  "messages.takeControl": "Take control",
  "messages.location": "Location",
  "messages.region": "Region",
  "messages.selectConversation": "Select a conversation",
  "messages.selectConversationDesc": "Choose a conversation from the list to view messages",
  "messages.priority.urgent": "Urgent",
  "messages.priority.high": "High",
  "messages.priority.normal": "Normal",
  "messages.handoff": "Handoff",
  "messages.handoffReason": "Reason",
  "messages.conversationWith": "Conversation with",
  "messages.messageCount": "{{count}} messages",
  "messages.lastMessage": "Last message",

  // ── Products ─────────────────────────────────────────────
  "products.title": "Products",
  "products.addProduct": "Add Product",
  "products.editProduct": "Edit Product",
  "products.newProduct": "New Product",
  "products.noProducts": "No products",
  "products.searchPlaceholder": "Search products...",
  "products.productName": "Product Name",
  "products.sku": "SKU",
  "products.price": "Price",
  "products.stock": "Stock",
  "products.unit": "Unit",

  // ── Product Families ─────────────────────────────────────
  "families.title": "Product Families",
  "families.addFamily": "Add Family",
  "families.editFamily": "Edit Family",
  "families.newFamily": "New Family",
  "families.addChild": "Add child",
  "families.copyProduct": "Copy product",
  "families.importProducts": "Import products",
  "families.viewDetails": "View details",
  "families.noFamilies": "No product families",
  "families.sellable": "Sellable",
  "families.notSellable": "Not sellable",
  "families.parentFamily": "Parent family",
  "families.noParent": "No parent (root)",
  "families.children": "children",
  "families.specifications": "Specifications",
  "families.materials": "Materials",
  "families.uses": "Uses",
  "families.appliances": "Applications",
  "families.onlineStoreLinks": "Online store links",
  "families.addLink": "Add link",
  "families.storeName": "Store name",
  "families.storeUrl": "Store URL",
  "families.productDetails": "Product Details",
  "families.breadcrumb": "Path",
  "families.showAll": "Show all",
  "families.collapseAll": "Collapse all",
  "families.expandAll": "Expand all",

  // ── Copy Product Modal ───────────────────────────────────
  "copyProduct.title": "Copy Product",
  "copyProduct.selectChildren": "Select children to copy",
  "copyProduct.selectAll": "Select all",
  "copyProduct.deselectAll": "Deselect all",
  "copyProduct.selectTarget": "Select destination",
  "copyProduct.targetParent": "Target family",
  "copyProduct.rootLevel": "Root level",
  "copyProduct.copy": "Copy",
  "copyProduct.copying": "Copying...",

  // ── Import Products Modal ────────────────────────────────
  "importProducts.title": "Import Products",
  "importProducts.target": "Import to: {{name}}",
  "importProducts.selectFile": "Select file",
  "importProducts.dragDrop": "Drag a file here or click to select",
  "importProducts.formats": "Accepted formats: CSV, Excel",
  "importProducts.importing": "Importing...",
  "importProducts.success": "Products imported successfully",
  "importProducts.error": "Error importing products",

  // ── Product Details Modal ────────────────────────────────
  "productDetails.title": "Product Details",
  "productDetails.generalInfo": "General Information",
  "productDetails.specs": "Specifications",
  "productDetails.noSpecs": "No specifications",
  "productDetails.images": "Images",
  "productDetails.noImages": "No images",

  // ── Campaigns ────────────────────────────────────────────
  "campaigns.title": "Campaigns",
  "campaigns.addCampaign": "New Campaign",
  "campaigns.editCampaign": "Edit Campaign",
  "campaigns.noCampaigns": "No campaigns",
  "campaigns.searchPlaceholder": "Search campaigns...",
  "campaigns.active": "Active",
  "campaigns.paused": "Paused",
  "campaigns.scheduled": "Scheduled",
  "campaigns.draft": "Draft",
  "campaigns.startDate": "Start date",
  "campaigns.endDate": "End date",
  "campaigns.budget": "Budget",
  "campaigns.objective": "Objective",
  "campaigns.catalogInherited": "Inherited catalog",
  "campaigns.ownCatalog": "Own catalog",

  // ── Campaign Modal ───────────────────────────────────────
  "campaignModal.title": "Campaign",
  "campaignModal.create": "Create Campaign",
  "campaignModal.edit": "Edit Campaign",
  "campaignModal.name": "Campaign name",
  "campaignModal.namePlaceholder": "E.g.: Summer Campaign 2025",
  "campaignModal.objective": "Objective",
  "campaignModal.objectivePlaceholder": "E.g.: Increase sales by 20%",
  "campaignModal.description": "Description",
  "campaignModal.descriptionPlaceholder": "Describe the campaign...",
  "campaignModal.startDate": "Start date",
  "campaignModal.endDate": "End date",
  "campaignModal.budget": "Budget",
  "campaignModal.active": "Active",
  "campaignModal.status": "Status",
  "campaignModal.catalog": "Catalog",
  "campaignModal.selectCatalog": "Select catalog",
  "campaignModal.useParentCatalog": "Use parent catalog",
  "campaignModal.adSetsSection": "Ad Sets",
  "campaignModal.addAdSet": "Add Ad Set",
  "campaignModal.adsSection": "Ads",
  "campaignModal.addAd": "Add Ad",
  "campaignModal.targetAudience": "Target audience",
  "campaignModal.targetAudiencePlaceholder": "Describe your target audience...",
  "campaignModal.trackingUrl": "Tracking URL",
  "campaignModal.general": "General",
  "campaignModal.schedule": "Schedule",
  "campaignModal.noAdSets": "No ad sets",
  "campaignModal.noAds": "No ads",
  "campaignModal.summary": "Summary",
  "campaignModal.summaryPlaceholder": "Brief ad summary...",
  "campaignModal.productFamilies": "Product families",
  "campaignModal.selectFamilies": "Select families",
  "campaignModal.inheritFromCampaign": "Inherit from campaign",
  "campaignModal.inheritFromAdSet": "Inherit from ad set",
  "campaignModal.ownSelection": "Own selection",
  "campaignModal.fbCampaignId": "Facebook Campaign ID",
  "campaignModal.fbAdSetId": "Facebook Ad Set ID",
  "campaignModal.fbAdId": "Facebook Ad ID",

  // ── Campaign Tree View ───────────────────────────────────
  "campaignTree.title": "Campaigns",
  "campaignTree.addCampaign": "New Campaign",
  "campaignTree.noCampaigns": "No campaigns",
  "campaignTree.searchPlaceholder": "Search...",
  "campaignTree.addAdSet": "Add Ad Set",
  "campaignTree.addAd": "Add Ad",
  "campaignTree.details": "Details",
  "campaignTree.expand": "Expand",
  "campaignTree.collapse": "Collapse",
  "campaignTree.expandAll": "Expand all",
  "campaignTree.collapseAll": "Collapse all",
  "campaignTree.mainTitle": "Ad Campaigns",
  "campaignTree.mainSubtitle": "Manage campaigns, ad sets and ads",
  "campaignTree.newCampaign": "New Campaign",
  "campaignTree.searchPlaceholderFull": "Search by ID, fbCampaignId, ref or name...",
  "campaignTree.loading": "Loading campaigns...",
  "campaignTree.noResults": "No results found",
  "campaignTree.noCampaignsFound": "No campaigns found",
  "campaignTree.noMatchQuery": "No campaigns match \"{{query}}\"",
  "campaignTree.startAdding": "Start by adding your first ad campaign",
  "campaignTree.addCampaignBtn": "Add Campaign",
  "campaignTree.activeCampaigns": "Active",
  "campaignTree.inactiveCampaigns": "Paused / Inactive",
  "campaignTree.typeCampaign": "Campaign",
  "campaignTree.typeAdSet": "Ad Set",
  "campaignTree.typeAd": "Ad",
  "campaignTree.typeItem": "Item",
  "campaignTree.noName": "Unnamed",
  "campaignTree.addAdSetTooltip": "Add Ad Set",
  "campaignTree.addAdTooltip": "Add Ad",
  "campaignTree.viewDetails": "View Details",
  "campaignTree.deactivateCampaign": "Deactivate campaign",
  "campaignTree.activateCampaign": "Activate campaign",
  "campaignTree.impressions": "impressions",
  "campaignTree.clicks": "clicks",
  "campaignTree.spent": "spent",
  "campaignTree.conversionsLabel": "conversions",
  "campaignTree.dailyBudget": "Daily budget",
  "campaignTree.lifetimeBudget": "Lifetime budget",
  "campaignTree.campaignActivated": "Campaign activated",
  "campaignTree.campaignDeactivated": "Campaign deactivated",
  "campaignTree.errorToggle": "Error changing status",
  "campaignTree.contract": "Collapse",
  "campaignTree.expandNode": "Expand",
  "campaignTree.viewDetailsTooltip": "View details",
  "campaignTree.activeFem": "Active",
  "campaignTree.inactiveFem": "Inactive",

  // ── Campaign Item Details Modal ──────────────────────────
  "campaignDetails.title": "Details",
  "campaignDetails.campaignInfo": "Campaign Information",
  "campaignDetails.adSetInfo": "Ad Set Information",
  "campaignDetails.adInfo": "Ad Information",
  "campaignDetails.noDetails": "No details available",

  // ── Ad Sets ──────────────────────────────────────────────
  "adSets.title": "Ad Sets",
  "adSets.addAdSet": "New Ad Set",
  "adSets.editAdSet": "Edit Ad Set",
  "adSets.noAdSets": "No ad sets",
  "adSets.searchPlaceholder": "Search ad sets...",
  "adSets.campaign": "Campaign",
  "adSets.selectCampaign": "Select campaign",
  "adSets.adsCount": "{{count}} ads",
  "adSets.name": "Ad Set name",
  "adSets.namePlaceholder": "E.g.: Main audience",

  // ── Ad Set Modal ─────────────────────────────────────────
  "adSetModal.title": "Ad Set",
  "adSetModal.create": "Create Ad Set",
  "adSetModal.edit": "Edit Ad Set",
  "adSetModal.name": "Name",
  "adSetModal.namePlaceholder": "Ad set name",
  "adSetModal.campaign": "Campaign",
  "adSetModal.selectCampaign": "Select campaign",
  "adSetModal.status": "Status",
  "adSetModal.budget": "Budget",
  "adSetModal.targeting": "Targeting",
  "adSetModal.catalog": "Catalog",

  // ── Ads ──────────────────────────────────────────────────
  "ads.title": "Ads",
  "ads.addAd": "New Ad",
  "ads.editAd": "Edit Ad",
  "ads.noAds": "No ads",
  "ads.searchPlaceholder": "Search ads...",
  "ads.adSet": "Ad Set",
  "ads.selectAdSet": "Select ad set",
  "ads.impressions": "Impressions",
  "ads.clicks": "Clicks",
  "ads.ctr": "CTR",
  "ads.conversions": "Conversions",
  "ads.name": "Ad name",

  // ── Ad Modal ─────────────────────────────────────────────
  "adModal.title": "Ad",
  "adModal.create": "Create Ad",
  "adModal.edit": "Edit Ad",
  "adModal.name": "Name",
  "adModal.namePlaceholder": "Ad name",
  "adModal.adSet": "Ad Set",
  "adModal.selectAdSet": "Select ad set",
  "adModal.type": "Ad type",
  "adModal.headline": "Headline",
  "adModal.headlinePlaceholder": "Ad headline",
  "adModal.body": "Ad text",
  "adModal.bodyPlaceholder": "Write the ad text...",
  "adModal.callToAction": "Call to action",
  "adModal.ctaPlaceholder": "E.g.: Buy now",
  "adModal.imageUrl": "Image URL",
  "adModal.imageUrlPlaceholder": "https://...",
  "adModal.linkUrl": "Destination URL",
  "adModal.linkUrlPlaceholder": "https://...",
  "adModal.status": "Status",
  "adModal.summary": "Summary",
  "adModal.summaryPlaceholder": "Brief ad summary",
  "adModal.catalog": "Catalog",
  "adModal.productFamilies": "Product families",
  "adModal.selectFamilies": "Select families",
  "adModal.fbAdId": "Facebook Ad ID",
  "adModal.fbAdIdPlaceholder": "Facebook ad ID",
  "adModal.trackingUrl": "Tracking URL",
  "adModal.clickUrl": "Click URL",
  "adModal.clickUrlPlaceholder": "Trackable link URL",

  // ── Campaign Products ────────────────────────────────────
  "campaignProducts.title": "Campaign Products",
  "campaignProducts.addProduct": "Add Product",
  "campaignProducts.noProducts": "No campaign products",

  // ── Master Catalog ───────────────────────────────────────
  "masterCatalog.title": "Master Catalog",
  "masterCatalog.addEntry": "New Entry",
  "masterCatalog.editEntry": "Edit Entry",
  "masterCatalog.noEntries": "No entries in the master catalog",
  "masterCatalog.searchPlaceholder": "Search master catalog...",
  "masterCatalog.family": "Family",
  "masterCatalog.subfamily": "Subfamily",
  "masterCatalog.materials": "Materials",
  "masterCatalog.generalUses": "General uses",
  "masterCatalog.generalSpecs": "General specifications",
  "masterCatalog.generalAppliances": "General applications",

  // ── Master Catalog Modal ─────────────────────────────────
  "masterCatalogModal.title": "Master Catalog Entry",
  "masterCatalogModal.create": "Create Entry",
  "masterCatalogModal.edit": "Edit Entry",
  "masterCatalogModal.selectFamily": "Select family",
  "masterCatalogModal.subfamilyName": "Subfamily name",
  "masterCatalogModal.subfamilyPlaceholder": "Subfamily name",
  "masterCatalogModal.materials": "Materials",
  "masterCatalogModal.materialsPlaceholder": "Materials used...",
  "masterCatalogModal.generalUses": "General uses",
  "masterCatalogModal.generalUsesPlaceholder": "General product uses...",
  "masterCatalogModal.generalSpecs": "General specifications (JSON)",
  "masterCatalogModal.generalAppliances": "General applications",
  "masterCatalogModal.generalAppliancesPlaceholder": "General applications...",

  // ── Usos y Grupos ───────────────────────────────────────
  "usosGrupos.title": "Uses & Groups",
  "usosGrupos.usosTab": "Uses",
  "usosGrupos.gruposTab": "Groups",

  // ── Usos ─────────────────────────────────────────────────
  "usos.title": "Uses",
  "usos.addUso": "New Use",
  "usos.editUso": "Edit Use",
  "usos.noUsos": "No uses",
  "usos.name": "Use name",
  "usos.namePlaceholder": "Use name",
  "usos.description": "Description",
  "usos.descriptionPlaceholder": "Use description...",

  // ── Usos Modal ───────────────────────────────────────────
  "usosModal.title": "Use",
  "usosModal.create": "Create Use",
  "usosModal.edit": "Edit Use",

  // ── Grupos ───────────────────────────────────────────────
  "grupos.title": "Groups",
  "grupos.addGrupo": "New Group",
  "grupos.editGrupo": "Edit Group",
  "grupos.noGrupos": "No groups",
  "grupos.name": "Group name",
  "grupos.namePlaceholder": "Group name",
  "grupos.description": "Description",
  "grupos.descriptionPlaceholder": "Group description...",

  // ── Grupos Modal ─────────────────────────────────────────
  "gruposModal.title": "Group",
  "gruposModal.create": "Create Group",
  "gruposModal.edit": "Edit Group",

  // ── Puntos de Venta ──────────────────────────────────────
  "pos.title": "Points of Sale",
  "pos.addPOS": "New Point of Sale",
  "pos.editPOS": "Edit Point of Sale",
  "pos.noPOS": "No points of sale",
  "pos.searchPlaceholder": "Search points of sale...",
  "pos.name": "Name",
  "pos.address": "Address",
  "pos.city": "City",
  "pos.state": "State",
  "pos.phone": "Phone",
  "pos.schedule": "Schedule",
  "pos.googleMapsUrl": "Google Maps URL",
  "pos.namePlaceholder": "Point of sale name",
  "pos.addressPlaceholder": "Full address",
  "pos.cityPlaceholder": "City",
  "pos.statePlaceholder": "State",
  "pos.phonePlaceholder": "Phone",
  "pos.schedulePlaceholder": "E.g.: Mon-Fri 9:00-18:00",
  "pos.googleMapsPlaceholder": "Google Maps URL",

  // ── Punto de Venta Modal ─────────────────────────────────
  "posModal.title": "Point of Sale",
  "posModal.create": "Create Point of Sale",
  "posModal.edit": "Edit Point of Sale",

  // ── Inventario ───────────────────────────────────────────
  "inventory.title": "Inventory",
  "inventory.searchPlaceholder": "Search inventory...",
  "inventory.noItems": "No items in inventory",
  "inventory.family": "Family",
  "inventory.product": "Product",
  "inventory.stock": "Stock",
  "inventory.minStock": "Minimum stock",
  "inventory.maxStock": "Maximum stock",
  "inventory.lastUpdated": "Last updated",
  "inventory.updateStock": "Update stock",
  "inventory.lowStock": "Low stock",
  "inventory.outOfStock": "Out of stock",
  "inventory.inStock": "In stock",

  // ── Users ────────────────────────────────────────────────
  "users.title": "Users",
  "users.addUser": "New User",
  "users.editUser": "Edit User",
  "users.noUsers": "No users",
  "users.searchPlaceholder": "Search users...",
  "users.username": "Username",
  "users.fullName": "Full name",
  "users.email": "Email",
  "users.role": "Role",
  "users.profile": "Profile",
  "users.lastLogin": "Last login",
  "users.createdAt": "Created",
  "users.deleteConfirm": "Are you sure you want to delete user \"{{name}}\"?",

  // ── User Modal ───────────────────────────────────────────
  "userModal.title": "User",
  "userModal.create": "Create User",
  "userModal.edit": "Edit User",
  "userModal.username": "Username",
  "userModal.usernamePlaceholder": "Username",
  "userModal.firstName": "First name",
  "userModal.firstNamePlaceholder": "First name",
  "userModal.lastName": "Last name",
  "userModal.lastNamePlaceholder": "Last name",
  "userModal.email": "Email",
  "userModal.emailPlaceholder": "email@example.com",
  "userModal.password": "Password",
  "userModal.passwordPlaceholder": "Minimum 6 characters",
  "userModal.passwordEditNote": "(Leave empty to keep current)",
  "userModal.role": "Role",
  "userModal.selectRole": "Select role",
  "userModal.profile": "Profile",
  "userModal.selectProfile": "Select profile",
  "userModal.permissions": "Permissions",

  // ── Roles ────────────────────────────────────────────────
  "roles.title": "Roles",
  "roles.addRole": "New Role",
  "roles.editRole": "Edit Role",
  "roles.noRoles": "No roles",
  "roles.searchPlaceholder": "Search roles...",
  "roles.name": "Name",
  "roles.label": "Label",
  "roles.usersCount": "Users",
  "roles.permissions": "Permissions",
  "roles.deleteConfirm": "Are you sure you want to delete the role \"{{name}}\"?",

  // ── Role Modal ───────────────────────────────────────────
  "roleModal.title": "Role",
  "roleModal.create": "Create Role",
  "roleModal.edit": "Edit Role",
  "roleModal.name": "Role name",
  "roleModal.namePlaceholder": "E.g.: super_admin",
  "roleModal.label": "Label",
  "roleModal.labelPlaceholder": "E.g.: Super Administrator",
  "roleModal.permissions": "Permissions",
  "roleModal.selectAll": "Select all",
  "roleModal.deselectAll": "Deselect all",

  // ── Profiles ─────────────────────────────────────────────
  "profiles.title": "Profiles",
  "profiles.addProfile": "New Profile",
  "profiles.editProfile": "Edit Profile",
  "profiles.noProfiles": "No profiles",
  "profiles.searchPlaceholder": "Search profiles...",
  "profiles.name": "Name",
  "profiles.label": "Label",
  "profiles.role": "Role",
  "profiles.deleteConfirm": "Are you sure you want to delete the profile \"{{name}}\"?",

  // ── Profile Modal ────────────────────────────────────────
  "profileModal.title": "Profile",
  "profileModal.create": "Create Profile",
  "profileModal.edit": "Edit Profile",
  "profileModal.name": "Profile name",
  "profileModal.namePlaceholder": "E.g.: accounting",
  "profileModal.label": "Label",
  "profileModal.labelPlaceholder": "E.g.: Accounting",
  "profileModal.role": "Associated role",
  "profileModal.selectRole": "Select role",

  // ── Click Logs ───────────────────────────────────────────
  "clickLogs.title": "Clicks",
  "clickLogs.noLogs": "No click logs",
  "clickLogs.searchPlaceholder": "Search clicks...",
  "clickLogs.adName": "Ad",
  "clickLogs.productName": "Product",
  "clickLogs.psid": "PSID",
  "clickLogs.timestamp": "Date",
  "clickLogs.converted": "Converted",
  "clickLogs.notConverted": "Not converted",
  "clickLogs.conversionDate": "Conversion date",
  "clickLogs.region": "Region",
  "clickLogs.all": "All",
  "clickLogs.convertedOnly": "Converted",
  "clickLogs.notConvertedOnly": "Not converted",
  "clickLogs.totalClicks": "Total clicks",
  "clickLogs.totalConversions": "Total conversions",
  "clickLogs.conversionRate": "Conversion rate",

  // ── Conversions ──────────────────────────────────────────
  "conversions.title": "Conversions",
  "conversions.noConversions": "No conversions",
  "conversions.searchPlaceholder": "Search conversions...",
  "conversions.product": "Product",
  "conversions.ad": "Ad",
  "conversions.date": "Date",
  "conversions.amount": "Amount",
  "conversions.status": "Status",
  "conversions.total": "Total conversions",
  "conversions.revenue": "Revenue",

  // ── Intents ──────────────────────────────────────────────
  "intents.title": "Intents",
  "intents.addIntent": "New Intent",
  "intents.editIntent": "Edit Intent",
  "intents.noIntents": "No intents",
  "intents.searchPlaceholder": "Search intents...",
  "intents.name": "Name",
  "intents.category": "Category",
  "intents.patterns": "Patterns",
  "intents.responses": "Responses",
  "intents.priority": "Priority",
  "intents.addCategory": "New Category",
  "intents.editCategory": "Edit Category",
  "intents.deleteConfirm": "Are you sure you want to delete the intent \"{{name}}\"?",
  "intents.examples": "Examples",
  "intents.addExample": "Add example",
  "intents.addResponse": "Add response",
  "intents.addPattern": "Add pattern",
  "intents.noCategories": "No categories",

  // ── Intent Modal ─────────────────────────────────────────
  "intentModal.title": "Intent",
  "intentModal.create": "Create Intent",
  "intentModal.edit": "Edit Intent",
  "intentModal.name": "Name",
  "intentModal.namePlaceholder": "Intent name",
  "intentModal.category": "Category",
  "intentModal.selectCategory": "Select category",
  "intentModal.patterns": "Detection patterns",
  "intentModal.patternsPlaceholder": "Add pattern...",
  "intentModal.responses": "Responses",
  "intentModal.responsePlaceholder": "Add response...",
  "intentModal.priority": "Priority",
  "intentModal.enabled": "Enabled",
  "intentModal.description": "Description",
  "intentModal.descriptionPlaceholder": "Intent description...",

  // ── Intent Category Modal ────────────────────────────────
  "intentCategoryModal.title": "Intent Category",
  "intentCategoryModal.create": "Create Category",
  "intentCategoryModal.edit": "Edit Category",
  "intentCategoryModal.name": "Name",
  "intentCategoryModal.namePlaceholder": "Category name",
  "intentCategoryModal.description": "Description",
  "intentCategoryModal.descriptionPlaceholder": "Category description...",

  // ── Flows ────────────────────────────────────────────────
  "flows.title": "Flows",
  "flows.addFlow": "New Flow",
  "flows.editFlow": "Edit Flow",
  "flows.noFlows": "No flows",
  "flows.searchPlaceholder": "Search flows...",
  "flows.name": "Name",
  "flows.trigger": "Trigger",
  "flows.steps": "Steps",
  "flows.deleteConfirm": "Are you sure you want to delete the flow \"{{name}}\"?",

  // ── Flow Modal ───────────────────────────────────────────
  "flowModal.title": "Flow",
  "flowModal.create": "Create Flow",
  "flowModal.edit": "Edit Flow",
  "flowModal.name": "Name",
  "flowModal.namePlaceholder": "Flow name",
  "flowModal.trigger": "Trigger",
  "flowModal.triggerPlaceholder": "Flow trigger",
  "flowModal.addStep": "Add step",
  "flowModal.stepType": "Step type",
  "flowModal.stepContent": "Content",

  // ── ML Orders ────────────────────────────────────────────
  "orders.title": "Mercado Libre Orders",
  "orders.noOrders": "No orders",
  "orders.searchPlaceholder": "Search orders...",
  "orders.orderId": "Order ID",
  "orders.buyer": "Buyer",
  "orders.product": "Product",
  "orders.quantity": "Quantity",
  "orders.total": "Total",
  "orders.date": "Date",
  "orders.status": "Status",
  "orders.shippingStatus": "Shipping status",

  // ── ML Importer ──────────────────────────────────────────
  "mlImporter.title": "Mercado Libre Importer",
  "mlImporter.description": "Import products from Mercado Libre to your catalog",
  "mlImporter.searchPlaceholder": "Search products on Mercado Libre...",
  "mlImporter.search": "Search",
  "mlImporter.searching": "Searching...",
  "mlImporter.noResults": "No results found",
  "mlImporter.import": "Import",
  "mlImporter.importing": "Importing...",
  "mlImporter.imported": "Imported",
  "mlImporter.price": "Price",
  "mlImporter.seller": "Seller",
  "mlImporter.condition": "Condition",
  "mlImporter.new": "New",
  "mlImporter.used": "Used",

  // ── ML Playground ────────────────────────────────────────
  "mlPlayground.title": "Playground - Mercado Libre",
  "mlPlayground.description": "Experiment with the Mercado Libre API",

  // ── Catalog Upload ───────────────────────────────────────
  "catalogUpload.title": "Upload Catalog",
  "catalogUpload.selectFile": "Select file",
  "catalogUpload.dragDrop": "Drag a file here",
  "catalogUpload.orClick": "or click to select",
  "catalogUpload.formats": "Formats: CSV, Excel (.xlsx)",
  "catalogUpload.uploading": "Uploading...",
  "catalogUpload.success": "Catalog uploaded successfully",
  "catalogUpload.error": "Error uploading catalog",
  "catalogUpload.preview": "Preview",
  "catalogUpload.rows": "rows",
  "catalogUpload.columns": "columns",
  "catalogUpload.upload": "Upload",
  "catalogUpload.mapping": "Column mapping",
  "catalogUpload.sourceColumn": "Source column",
  "catalogUpload.targetField": "Target field",
  "catalogUpload.skip": "Skip",

  // ── Purchase Intent Stats ────────────────────────────────
  "purchaseIntent.title": "Purchase Intent",
  "purchaseIntent.total": "Total intents",
  "purchaseIntent.converted": "Converted",
  "purchaseIntent.pending": "Pending",
  "purchaseIntent.conversionRate": "Conversion rate",

  // ── Tracked Link Generator ───────────────────────────────
  "trackedLink.title": "Tracked Link Generator",
  "trackedLink.baseUrl": "Base URL",
  "trackedLink.baseUrlPlaceholder": "https://...",
  "trackedLink.campaign": "Campaign",
  "trackedLink.selectCampaign": "Select campaign",
  "trackedLink.adSet": "Ad Set",
  "trackedLink.selectAdSet": "Select ad set",
  "trackedLink.ad": "Ad",
  "trackedLink.selectAd": "Select ad",
  "trackedLink.generate": "Generate link",
  "trackedLink.generatedLink": "Generated link",
  "trackedLink.copy": "Copy",
  "trackedLink.copied": "Copied!",

  // ── API Health Alerts ────────────────────────────────────
  "apiHealth.title": "API Status",
  "apiHealth.healthy": "API running correctly",
  "apiHealth.degraded": "API with degraded performance",
  "apiHealth.down": "API unavailable",
  "apiHealth.checking": "Checking API status...",
  "apiHealth.lastCheck": "Last check",
  "apiHealth.responseTime": "Response time",

  // ── Simulation Mode Selector ─────────────────────────────
  "simulationSelector.title": "Role Simulation",
  "simulationSelector.selectRole": "Select role",
  "simulationSelector.selectProfile": "Select profile",
  "simulationSelector.start": "Simulate",
  "simulationSelector.viewing": "Simulating:",
  "simulationSelector.stop": "Stop",

  // ── Product Tree Selector ────────────────────────────────
  "productTreeSelector.title": "Select Products",
  "productTreeSelector.searchPlaceholder": "Search family...",
  "productTreeSelector.noFamilies": "No families available",
  "productTreeSelector.selectAll": "Select all",
  "productTreeSelector.deselectAll": "Deselect all",
  "productTreeSelector.selected": "selected",

  // ── Messages Page (extended) ─────────────────────────────
  "messages.loadingConversations": "Loading conversations...",
  "messages.refreshing": "Refreshing...",
  "messages.refresh": "Refresh",
  "messages.pendingAttention": "Pending Attention",
  "credit.lowBanner": "OpenAI credit is low: ~{{amount}} left (~{{days}} days). At $0 the bot stops replying.",
  "credit.review": "Review",
  "credit.lowBannerNoDays": "OpenAI credit is low: ~{{amount}} left. At $0 the bot stops replying.",
  "messages.coldLeads": "Leads with no contact",
  "messages.coldLeadsHint": "They went silent without giving a phone or a ZIP — nobody was alerted. They leave this list if they write back.",
  "messages.coldSince": "Silent since",
  "messages.coldWhy": "Missing",
  "messages.origin": "Origin",
  "messages.show": "Show",
  "messages.hide": "Hide",
  "messages.channel": "Channel",
  "messages.user": "User",
  "messages.waitingSince": "Waiting since",
  "messages.reason": "Reason",
  "messages.product": "Product",
  "messages.city": "City",
  "messages.intent": "Intent",
  "messages.action": "Action",
  "messages.afterHours": "After hours",
  "messages.take": "Take",
  "messages.recentActivity": "Recent Activity - Last 10 Conversations",
  "messages.date": "Date",
  "messages.lastMessageCol": "Last message",
  "messages.spokesperson": "Spokesperson",
  "messages.human": "Human",
  "messages.bot": "Bot",
  "messages.releaseBot": "Release",
  "messages.takeOver": "Take",
  "messages.releaseToBot": "Release to Bot",
  "messages.allConversations": "All Conversations",
  "messages.conversationCount": "{{count}} conversation",
  "messages.conversationCountPlural": "{{count}} conversations",
  "messages.needsHelp": "{{count}} conversation needs help",
  "messages.needsHelpPlural": "{{count}} conversations need help",
  "messages.filterToday": "Today",
  "messages.filterYesterday": "Yesterday",
  "messages.filterWeek": "Last 7 days",
  "messages.filterMonth": "Last 30 days",
  "messages.filterAll": "All",
  "messages.senderType": "Type",
  "messages.previous": "Previous",
  "messages.page": "Page {{current}} of {{total}} ({{count}} conversations)",
  "messages.next": "Next",
  "messages.conversation": "Conversation",
  "messages.whatsappNote": "WhatsApp • You can call or send a direct message",
  "messages.originOrganic": "Organic (no ad)",
  "messages.originOrganicHint": "The customer wrote in directly, not from an ad",
  "messages.originAdInactive": "This ad is no longer running",
  "messages.replyVia": "Reply via {{channel}}...",
  "messages.status": "Status",
  "messages.allAds": "All ads",
  "messages.resumeBot": "Resume Bot",
  "messages.resumeBotTitle": "Re-process customer's last message with the bot",
  "messages.noResponse": "Bot generated no response",
  "messages.closeLink": "Close Link",
  "messages.generateLink": "Generate Link",
  "messages.close": "Close",
  "messages.copyStoreLink": "Copy ML store link with PSID",
  "messages.storeLinkCopied": "Store link with PSID copied",
  "messages.agent": "Agent",
  "messages.numberCopied": "Number copied: {{number}}",
  "messages.copy": "Copy",
  "messages.copyNumber": "Copy number",
  "messages.openWhatsApp": "Open in WhatsApp",
  "messages.sendChannel": "Send {{icon}}",
  "messages.reportTools": "Sale / report options",
  "canned.button": "Quick replies",
  "canned.search": "Search reply…",
  "canned.new": "New reply",
  "canned.edit": "Edit",
  "canned.delete": "Delete",
  "canned.confirmDelete": "Delete this reply?",
  "canned.empty": "No saved replies yet. Create your first one. 👇",
  "canned.noResults": "No matches",
  "canned.titlePlaceholder": "Short title (e.g. Shipping)",
  "canned.bodyPlaceholder": "Type the message…",
  "canned.cancel": "Cancel",
  "canned.save": "Save",
  "messages.errorSending": "Error sending message",
  "messages.intentHigh": "High",
  "messages.intentMedium": "Medium",
  "messages.intentLow": "Low",
  "messages.handoffUrgent": "Urgent",
  "messages.handoffActionRequired": "Action Required",
  "messages.handoffInfo": "Informational",
  "messages.agoMinutes": "{{count}}min ago",
  "messages.agoHours": "{{count}}h ago",
  "messages.agoDays": "{{count}}d ago",

  // ── Orders Page (extended) ─────────────────────────────
  "orders.periodOrders": "Period Orders",
  "orders.periodRevenue": "Period Revenue",
  "orders.avgTicket": "Avg Ticket",
  "orders.fbAttribution": "Facebook Attribution",
  "orders.loading": "Loading...",
  "orders.calculatingTotal": "Calculating total...",
  "orders.fromCurrentPage": "From current page",
  "orders.totalFromOrders": "Total from {{count}} orders",
  "orders.basedOnPeriod": "Based on period total",
  "orders.ofOrders": "{{count}} of {{total}} orders",
  "orders.topProduct": "Top Product",
  "orders.calculating": "Calculating...",
  "orders.units": "{{count}} units",
  "orders.orderCount": "{{count}} orders",
  "orders.noData": "No data",
  "orders.topBuyer": "Top Buyer",
  "orders.sellerId": "Seller ID",
  "orders.dateFrom": "From",
  "orders.dateTo": "To",
  "orders.searchOrders": "Search Orders",
  "orders.loadingOrders": "Loading orders...",
  "orders.noOrdersFound": "No orders",
  "orders.noOrdersDesc": "No orders found for this seller",
  "orders.order": "Order",
  "orders.more": "+{{count}} more",
  "orders.showing": "Showing {{from}} - {{to}} of {{total}} orders",
  "orders.maxAccessible": "(max. {{max}} accessible)",
  "orders.firstPage": "First page",
  "orders.lastPage": "Last page",
  "orders.pageOf": "Page {{current}} of {{total}}",
  "orders.noAuthToken": "No authentication token found. Please login.",

  // ── Conversions Page (extended) ────────────────────────
  "conversions.pageTitle": "Conversions Meta → Mercado Libre",
  "conversions.pageSubtitle": "Sales attribution from Facebook Messenger",
  "conversions.loadingData": "Loading conversion data...",
  "conversions.conversions": "Conversions",
  "conversions.ofClicks": "{{rate}}% of clicks",
  "conversions.attributedRevenue": "FB Attributed Revenue",
  "conversions.correlatedOrders": "from {{count}} correlated orders",
  "conversions.clickedLinks": "Clicked Links",
  "conversions.clickRate": "{{rate}}% click rate",
  "conversions.attributionConfidence": "Attribution Confidence",
  "conversions.high": "High",
  "conversions.medium": "Medium",
  "conversions.low": "Low",
  "conversions.chartTitle": "Clicks vs Conversions by Day",
  "conversions.chartConversions": "Conversions",
  "conversions.chartClicks": "Clicks",
  "conversions.correlation": "Correlation",
  "conversions.from": "From",
  "conversions.to": "To",
  "conversions.windowHours": "Window (hrs)",
  "conversions.limit": "Limit",
  "conversions.updateStats": "Update Stats",
  "conversions.preview": "Preview",
  "conversions.syncNow": "Sync Now",
  "conversions.processing": "Processing...",
  "conversions.previewTitle": "Preview (not saved)",
  "conversions.correlationComplete": "Correlation Complete",
  "conversions.ordersProcessed": "Orders processed:",
  "conversions.withClicks": "With clicks:",
  "conversions.clicksCorrelated": "Clicks correlated:",
  "conversions.matchRate": "Match rate:",
  "conversions.correlationsFound": "Correlations found:",
  "conversions.topBuyers": "Top Buyers",
  "conversions.purchaseCount": "{{count}} purchase",
  "conversions.purchaseCountPlural": "{{count}} purchases",
  "conversions.userDefault": "User",
  "conversions.recentConversions": "Recent Conversions",
  "conversions.show": "Show:",
  "conversions.noConversionsRecorded": "No conversions recorded",
  "conversions.colProduct": "Product",
  "conversions.colBuyer": "Buyer",
  "conversions.colCity": "City",
  "conversions.colClick": "Click",
  "conversions.colOrder": "Order",
  "conversions.colMethod": "Method",
  "conversions.colDetail": "Detail",
  "conversions.colAmount": "Amount",
  "conversions.colConfidence": "Confidence",
  "conversions.showingRange": "Showing {{from}} - {{to}} of {{total}}",
  "conversions.pageOf": "Page {{current}} of {{total}}",
  "conversions.funnelTitle": "Attribution Funnel",
  "conversions.linksGenerated": "Links Generated",
  "conversions.clicks": "Clicks",
  "conversions.funnelConversions": "Conversions",
  "conversions.fbRevenue": "FB Revenue",
  "conversions.orders": "{{count}} orders",

  // ── Inventory Page (extended) ──────────────────────────
  "inventory.sellableProducts": "{{count}} sellable products",
  "inventory.searchPlaceholderFull": "Search by name, size or color...",
  "inventory.syncML": "Sync ML",
  "inventory.syncing": "Syncing...",
  "inventory.synced": "{{count}} synced",
  "inventory.errors": "{{count}} errors",
  "inventory.deactivateUnpriced": "Deactivate unpriced",
  "inventory.exportExcel": "Export Excel",
  "inventory.uploadPrices": "Update prices (Excel)",
  "inventory.uploading": "Uploading…",
  "inventory.uploadDone": "Prices: {{price}} · Links: {{link}} · Unchanged: {{unchanged}}",
  "inventory.uploadNotFound": "Not found: {{count}}",
  "inventory.uploadInvalid": "No valid price: {{count}}",
  "inventory.pasteMLLabel": "Or paste the Mercado Libre link directly",
  "inventory.saveLink": "Save link",
  "inventory.invalidMLUrl": "The link must be a Mercado Libre URL",
  "inventory.selected": "{{count}} selected",
  "inventory.operation": "Operation...",
  "inventory.opPrice": "Price",
  "inventory.opStock": "Stock",
  "inventory.opActivate": "Activate",
  "inventory.opDeactivate": "Deactivate",
  "inventory.apply": "Apply",
  "inventory.loadingInventory": "Loading inventory...",
  "inventory.noProductsFound": "No products found",
  "inventory.productsCount": "{{count}} products",
  "inventory.colCode": "Code",
  "inventory.colProduct": "Product",
  "inventory.colSize": "Size",
  "inventory.colColor": "Color",
  "inventory.colStock": "Stock",
  "inventory.colPrice": "Price",
  "inventory.colMinQty": "Min Qty",
  "inventory.colWholesale": "Wholesale",
  "inventory.colActive": "Active",
  "inventory.importFromML": "Import from Mercado Libre",
  "inventory.linking": "Linking:",
  "inventory.searchMinChars": "Type at least 3 characters to search...",
  "inventory.searchMinCharsML": "Type at least 3 characters to search ML products",
  "inventory.searching": "Searching...",
  "inventory.showingOf": "Showing {{shown}} of {{total}} results",
  "inventory.noMLProducts": "No products found",
  "inventory.cancel": "Cancel",
  "inventory.linkML": "Link",
  "inventory.changeMLLink": "Change ML link",
  "inventory.importML": "Import from ML",
  "inventory.selectAtLeast": "Select at least one product",
  "inventory.selectOperation": "Select an operation",
  "inventory.enterValidValue": "Enter a valid value",
  "inventory.someUpdatesFailed": "Some products could not be updated",
  "inventory.errorUpdating": "Error updating",
  "inventory.errorUpdateProduct": "Error updating: ",
  "inventory.noUnconfirmed": "No products with unconfirmed prices",
  "inventory.deactivateConfirm": "Deactivate {{count}} products without confirmed price?",
  "inventory.errorDeactivating": "Error deactivating products",
  "inventory.errorLinking": "Error linking: ",
  "inventory.errorLinkingProduct": "Error linking product",
  "inventory.confirmPrice": "Confirm price",
  "inventory.errorSyncPrices": "Error syncing prices: ",
  "inventory.errorSyncPricesML": "Error syncing ML prices",
  "inventory.view": "View",

  // ── ML Importer Page (extended) ────────────────────────
  "mlImporter.pageTitle": "ML Importer",
  "mlImporter.pageSubtitle": "Link Mercado Libre products with your inventory",
  "mlImporter.totalML": "Total ML:",
  "mlImporter.linked": "Linked:",
  "mlImporter.unlinked": "Unlinked:",
  "mlImporter.unavailable": "Unavailable:",
  "mlImporter.inactive": "Inactive:",
  "mlImporter.updateML": "Refresh ML",
  "mlImporter.loadingML": "Loading Mercado Libre products... (this may take a few seconds)",
  "mlImporter.loadingInventory": "Loading inventory...",
  "mlImporter.searchML": "Search ML...",
  "mlImporter.filterAll": "All",
  "mlImporter.filterUnlinked": "Unlinked",
  "mlImporter.filterLinked": "Linked",
  "mlImporter.filterInactive": "Inactive",
  "mlImporter.noProductsFound": "No products found",
  "mlImporter.notAvailable": "Unavailable",
  "mlImporter.inactiveLabel": "Inactive",
  "mlImporter.linkedLabel": "Linked",
  "mlImporter.viewInML": "View in ML",
  "mlImporter.linkedTo": "Linked to:",
  "mlImporter.pausedInML": "Paused in ML",
  "mlImporter.reactivate": "Reactivate",
  "mlImporter.unlink": "Unlink",
  "mlImporter.deactivate": "Deactivate",
  "mlImporter.link": "Link",
  "mlImporter.linkMLProduct": "Link ML product",
  "mlImporter.searchInventory": "Search product in inventory...",
  "mlImporter.alreadyHasML": "Already has ML link",
  "mlImporter.showingOf": "Showing {{shown}} of {{total}} results",
  "mlImporter.cancel": "Cancel",
  "mlImporter.unlinkConfirm": "Unlink this product from ML?",
  "mlImporter.errorLoading": "Error loading ML: ",
  "mlImporter.connectionError": "Connection error: ",
  "mlImporter.errorLinking": "Error linking: ",
  "mlImporter.errorLinkingProduct": "Error linking product",
  "mlImporter.errorUnlinking": "Error unlinking: ",
  "mlImporter.errorUnlinkingProduct": "Error unlinking product",

  // ── ML Playground Page (extended) ──────────────────────
  "mlPlayground.pageTitle": "ML API Playground",
  "mlPlayground.pageSubtitle": "Test Mercado Libre integrations",
  "mlPlayground.connectionStatus": "Connection Status",
  "mlPlayground.connectedAs": "Connected as {{nickname}} ({{id}})",
  "mlPlayground.notConnected": "Not connected",
  "mlPlayground.verifying": "Verifying...",
  "mlPlayground.verify": "Verify",
  "mlPlayground.itemsInML": "Items in ML",
  "mlPlayground.loadItems": "Load Items",
  "mlPlayground.loadingItems": "Loading...",
  "mlPlayground.searchPlaceholder": "Search by title, ID or SKU...",
  "mlPlayground.clickToLoad": "Click \"Load Items\" to see your listings",
  "mlPlayground.noItemsFound": "No items found",
  "mlPlayground.itemDetails": "Item Details",
  "mlPlayground.selectItem": "Select an item to view its details",
  "mlPlayground.viewInML": "View in ML",
  "mlPlayground.currentPrice": "Current price:",
  "mlPlayground.originalPrice": "Original price:",
  "mlPlayground.status": "Status:",
  "mlPlayground.available": "Available:",
  "mlPlayground.sold": "Sold:",
  "mlPlayground.sku": "SKU:",
  "mlPlayground.updatePrice": "Update Price",
  "mlPlayground.newPricePlaceholder": "New price",
  "mlPlayground.updating": "Updating...",
  "mlPlayground.update": "Update",
  "mlPlayground.priceNote": "Note: If the item has an active promotion, the price may not be updated.",
  "mlPlayground.invalidPrice": "Invalid price",
  // eslint-disable-next-line no-template-curly-in-string
  "mlPlayground.priceUpdated": "Price updated to ${{price}}",
  "mlPlayground.errorUpdatePrice": "Error updating price",
  "mlPlayground.errorStatus": "Error checking ML status",
  "mlPlayground.errorItems": "Error fetching items",
  "mlPlayground.errorDetails": "Error fetching item details",
  "mlPlayground.apiLog": "API Log",
  "mlPlayground.clearLog": "Clear",
  "mlPlayground.noActivity": "No activity recorded",

  // ── Puntos de Venta Page (extended) ────────────────────
  "pos.pageTitle": "Points of Sale",
  "pos.pageSubtitle": "Manage online stores where products are sold",
  "pos.newPOS": "New Point of Sale",
  "pos.listTitle": "Points of Sale List",
  "pos.loadingPOS": "Loading points of sale...",
  "pos.noPOSRegistered": "No points of sale registered",
  "pos.startAdding": "Start by adding the first point of sale",
  "pos.addPOSButton": "Add Point of Sale",
  "pos.nameCol": "Name",
  "pos.baseUrl": "Base URL",
  "pos.descriptionCol": "Description",
  "pos.actionsCol": "Actions",
  "pos.inactiveLabel": "Inactive",
  "pos.editTooltip": "Edit",
  "pos.deleteTooltip": "Delete",

  // ── Home Page ────────────────────────────────────────────
  "home.welcome": "Welcome",
  "home.subtitle": "Hanlob Bot admin dashboard",

  // ── adModal ──
  "adModal.adAngle": "Ad Angle",
  "adModal.adSetRequired": "Ad Set *",
  "adModal.associatedProducts": "Associated Products",
  "adModal.audienceTypeLabel": "Audience Type",
  "adModal.audienceTypePlaceholder": "Select audience type...",
  "adModal.botCustomization": "Bot Response Customization",
  "adModal.botCustomizationHint": "These settings override the campaign defaults for this specific ad",
  "adModal.callToActionLabel": "Call to Action (CTA)",
  "adModal.catalogSaveFirst": "Save the ad first to upload a catalog.",
  "adModal.creativeContent": "Creative Content",
  "adModal.ctaContactUs": "Contact Us",
  "adModal.ctaGetQuote": "Get Quote",
  "adModal.ctaLearnMore": "Learn More",
  "adModal.ctaShopNow": "Shop Now",
  "adModal.ctaSignUp": "Sign Up",
  "adModal.descriptionLabel": "Description",
  "adModal.descriptionPlaceholder": "Description of the ad creative...",
  "adModal.destinationUrl": "Destination URL",
  "adModal.fbAdIdRequired": "FB Ad ID *",
  "adModal.mainProduct": "Main Product",
  "adModal.mainProductHint": "The primary product featured in this ad",
  "adModal.nameRequired": "Name *",
  "adModal.noAngle": "No angle",
  "adModal.offerHookHint": "Special offer to attract customers",
  "adModal.offerHookLabel": "Offer/Hook",
  "adModal.offerHookPlaceholder": "20% off + free shipping",
  "adModal.primaryUse": "Primary Use",
  "adModal.primaryUsePlaceholder": "Select primary use...",
  "adModal.productsNote": "Products selected here will be available to the bot for this ad",
  "adModal.selectAdSetOption": "Select Ad Set...",
  "adModal.statusActive": "Active",
  "adModal.statusArchived": "Archived",
  "adModal.statusPaused": "Paused",
  "adModal.updateAd": "Update Ad",
  "adModal.useFirstProduct": "Use first product",
  "adModal.videoUrl": "Video URL",
  "adModal.tracking": "Tracking (UTMs)",
  "adModal.trackingHint": "UTM parameters for campaign tracking",
  "adModal.utmSource": "utm_source",
  "adModal.utmMedium": "utm_medium",
  "adModal.utmCampaign": "utm_campaign",
  "adModal.utmContent": "utm_content",
  "adModal.utmTerm": "utm_term",

  // ── adSetModal ──
  "adSetModal.ageMax": "Max Age",
  "adSetModal.ageMin": "Min Age",
  "adSetModal.associatedProducts": "Associated Products",
  "adSetModal.billingEvent": "Billing Event",
  "adSetModal.dailyBudget": "Daily Budget ($)",
  "adSetModal.fbAdSetId": "FB AdSet ID",
  "adSetModal.locations": "Locations",
  "adSetModal.optimizationGoal": "Optimization Goal",
  "adSetModal.placements": "Ad Placements",
  "adSetModal.productsNote": "Products selected here will be available to the bot for ads in this ad set",
  "adSetModal.saveCatalogFirst": "Save the ad set first to upload a catalog.",
  "adSetModal.selectCampaignOption": "Select Campaign...",
  "adSetModal.statusActive": "Active",
  "adSetModal.statusArchived": "Archived",
  "adSetModal.statusPaused": "Paused",
  "adSetModal.update": "Update Ad Set",
  "adSetModal.genders": "Genders",
  "adSetModal.gendersPlaceholder": "Men, Women or all",
  "adSetModal.interests": "Interests",
  "adSetModal.interestsPlaceholder": "Agriculture, Gardening, Construction",
  "adSetModal.behaviors": "Behaviors",
  "adSetModal.behaviorsPlaceholder": "Frequent buyers",
  "adSetModal.customAudiences": "Custom Audiences",
  "adSetModal.customAudiencesPlaceholder": "Lookalike MX 1%, Retargeting 30d",

  // ── adSets ──
  "adSets.subtitle": "Grouped by campaign",
  "adSets.newAdSet": "New Ad Set",
  "adSets.adSetDetails": "Ad Set Details",
  "adSets.basicInfo": "Basic Info",
  "adSets.targeting": "Targeting",
  "adSets.budgetOptimization": "Budget & Optimization",
  "adSets.metrics": "Metrics",
  "adSets.active": "Active",
  "adSets.paused": "Paused",
  "adSets.archived": "Archived",
  "adSets.age": "Age",
  "adSets.locations": "Locations",
  "adSets.gender": "Gender",
  "adSets.interests": "Interests",
  "adSets.dailyBudget": "Daily Budget",
  "adSets.lifetimeBudget": "Lifetime Budget",
  "adSets.close": "Close",
  "adSets.activeAds": "active ads",
  "adSets.noAdsInSet": "No ads in this ad set",
  "adSets.loading": "Loading ad sets...",
  "adSets.errorLoad": "Error loading ad sets",
  "adSets.errorSave": "Error saving ad set",
  "adSets.errorDelete": "Error deleting ad set",
  "adSets.savedSuccess": "Ad set saved successfully",
  "adSets.deletedSuccess": "Ad set deleted successfully",
  "adSets.confirmDelete": "Are you sure you want to delete this ad set?",
  "adSets.fbAdSetId": "FB AdSet ID",
  "adSets.optimizationGoal": "Optimization Goal",
  "adSets.billingEvent": "Billing Event",
  "adSets.placements": "Placements",
  "adSets.bid": "Bid",
  "adSets.impressions": "Impressions",
  "adSets.clicks": "Clicks",
  "adSets.spend": "Spend",
  "adSets.conversions": "Conversions",
  "adSets.createdAt": "Created",
  "adSets.updatedAt": "Updated",
  "adSets.adCreatedSuccess": "Ad created successfully",
  "adSets.adUpdatedSuccess": "Ad updated successfully",
  "adSets.adErrorSave": "Error saving ad",
  "adSets.adErrorSaveDetail": "Error saving ad details",
  "adSets.groupedByCampaign": "Grouped by campaign",
  "adSets.emptyDescription": "Ad sets will be created automatically with campaigns",
  "adSets.internalId": "Internal ID",
  "adSets.budgetAndOptimization": "Budget & Optimization",
  "adSets.metricsSection": "Metrics",
  "adSets.impressionsLabel": "Impressions",
  "adSets.clicksLabel": "Clicks",
  "adSets.conversionsLabel": "Conversions",
  "adSets.spendLabel": "Spend",
  "adSets.reachLabel": "Reach",
  "adSets.ctrLabel": "CTR",
  "adSets.updatedSuccess": "Ad Set updated successfully",
  "adSets.createdSuccess": "Ad Set created successfully",
  "adSets.errorSaveDetail": "Error saving ad set: ",
  "adSets.statusUpdated": "Status updated",
  "adSets.errorUpdateStatus": "Error updating status",
  "adSets.statusActive": "Active",
  "adSets.statusPaused": "Paused",
  "adSets.viewDetails": "View Details",
  "adSets.noCampaign": "No Campaign",
  "adSets.targetingSection": "Targeting",

  // ── ads ──
  "ads.subtitle": "Grouped by campaign and ad set",
  "ads.newAd": "New Ad",
  "ads.noAdsMessage": "Ads will be created automatically with campaigns",
  "ads.adDetails": "Ad Details",
  "ads.basicInfo": "Basic Info",
  "ads.creative": "Creative",
  "ads.tracking": "Tracking",
  "ads.botCustomization": "Bot Customization",
  "ads.metrics": "Metrics",
  "ads.systemInfo": "System Info",
  "ads.active": "Active",
  "ads.paused": "Paused",
  "ads.archived": "Archived",
  "ads.campaign": "Campaign",
  "ads.ref": "Ref",
  "ads.destinationUrl": "Destination URL",
  "ads.adAngle": "Ad Angle",
  "ads.cta": "CTA",
  "ads.offerHook": "Offer/Hook",
  "ads.description": "Description",
  "ads.fbAdId": "FB Ad ID",
  "ads.pixelId": "Pixel ID",
  "ads.pixelEvent": "Pixel Event",
  "ads.responseTone": "Response Tone",
  "ads.spend": "Spend",
  "ads.cpc": "CPC",
  "ads.createdAt": "Created",
  "ads.updatedAt": "Updated",
  "ads.close": "Close",
  "ads.loading": "Loading ads...",
  "ads.audienceType": "Audience Type",
  "ads.errorLoad": "Error loading ads",
  "ads.errorSave": "Error saving ad",
  "ads.errorDelete": "Error deleting ad",
  "ads.savedSuccess": "Ad saved successfully",
  "ads.deletedSuccess": "Ad deleted successfully",
  "ads.confirmDelete": "Are you sure you want to delete this ad?",
  "ads.noName": "Unnamed",
  "ads.adSummary": "Ad Summary",
  "ads.initialMessage": "Initial Message",
  "ads.products": "Products",
  "ads.none": "None",
  "ads.noAdsInSet": "No ads in this ad set",
  "ads.mainProduct": "Main Product",
  "ads.primaryUse": "Primary Use",
  "ads.groupedByCampaign": "Grouped by campaign and ad set",
  "ads.emptyDescription": "Ads will be created automatically with campaigns",
  "ads.activeCount": "active",
  "ads.associatedProducts": "Associated Products",
  "ads.productsCount": "products",
  "ads.internalId": "Internal ID",
  "ads.mainText": "Main Text",
  "ads.callToAction": "Call to Action",
  "ads.video": "Video",
  "ads.trackingSection": "Tracking",
  "ads.notConfigured": "Not configured",
  "ads.anglePriceSensitive": "Price - Focus on value/affordable pricing",
  "ads.angleQualityPremium": "Quality Premium - Focus on durability",
  "ads.angleUrgencyOffer": "Urgency - Limited time offer",
  "ads.angleProblemPain": "Problem/Pain - Solution to sun/heat",
  "ads.angleBulkB2b": "Wholesale/B2B - Business focus",
  "ads.angleDiyEase": "Easy Install - Do it yourself",
  "ads.angleComparisonSwitching": "Comparison - Better than alternatives",
  "ads.metricsSection": "Metrics",
  "ads.impressionsLabel": "Impressions",
  "ads.clicksLabel": "Clicks",
  "ads.conversionsLabel": "Conversions",
  "ads.spendLabel": "Spend",
  "ads.reachLabel": "Reach",
  "ads.ctrLabel": "CTR",
  "ads.cpcLabel": "CPC",
  "ads.cpmLabel": "CPM",
  "ads.updatedSuccess": "Ad updated successfully",
  "ads.createdSuccess": "Ad created successfully",
  "ads.errorSaveDetail": "Error saving ad: ",
  "ads.errorUnknown": "Unknown error",
  "ads.statusUpdated": "Status updated successfully",
  "ads.errorUpdateStatus": "Error updating status",
  "ads.errorUpdateStatusDetail": "Error updating status: ",
  "ads.statusActive": "Active",
  "ads.statusPaused": "Paused",
  "ads.statusArchived": "Archived",
  "ads.viewDetails": "View Details",
  "ads.noCampaign": "No Campaign",
  "ads.noAdSet": "No Ad Set",

  // ── apiHealth ──
  "apiHealth.error": "Error",
  "apiHealth.apiErrorDetected": "API error detected",
  "apiHealth.consecutiveErrors": "Consecutive errors:",
  "apiHealth.errorsLast24h": "Errors in 24h:",
  "apiHealth.since": "Since:",
  "apiHealth.hideAlert": "Hide alert",

  // ── campaignDetails ──
  "campaignDetails.basicInfo": "Basic Info",
  "campaignDetails.fbConfig": "Facebook Configuration",
  "campaignDetails.budget": "Budget",
  "campaignDetails.dates": "Dates",
  "campaignDetails.botConfig": "Bot Configuration",
  "campaignDetails.metrics": "Metrics",
  "campaignDetails.ref": "Ref",
  "campaignDetails.trafficSource": "Traffic Source",
  "campaignDetails.conversationGoal": "Conversation Goal",
  "campaignDetails.responseTone": "Response Tone",
  "campaignDetails.adAngle": "Ad Angle",
  "campaignDetails.cta": "CTA",
  "campaignDetails.offerHook": "Offer/Hook",
  "campaignDetails.initialMessage": "Initial Message",
  "campaignDetails.fbCampaignId": "FB Campaign ID",
  "campaignDetails.fbAdAccountId": "FB Ad Account ID",
  "campaignDetails.objective": "Objective",
  "campaignDetails.dailyBudget": "Daily Budget",
  "campaignDetails.lifetimeBudget": "Lifetime Budget",
  "campaignDetails.startDate": "Start Date",
  "campaignDetails.endDate": "End Date",
  "campaignDetails.notSet": "Not set",
  "campaignDetails.close": "Close",
  "campaignDetails.typeCampaign": "Campaign",
  "campaignDetails.typeAdSet": "Ad Set",
  "campaignDetails.typeAd": "Ad",
  "campaignDetails.typeItem": "Item",
  "campaignDetails.detailsOf": "{{type}} Details",
  "campaignDetails.noName": "Unnamed",
  "campaignDetails.name": "Name",
  "campaignDetails.reference": "Reference",
  "campaignDetails.status": "Status",
  "campaignDetails.facebookId": "Facebook ID",
  "campaignDetails.internalId": "Internal ID",
  "campaignDetails.description": "Description",
  "campaignDetails.daily": "Daily",
  "campaignDetails.total": "Total",
  "campaignDetails.targeting": "Targeting",
  "campaignDetails.locations": "Locations",
  "campaignDetails.age": "Age",
  "campaignDetails.optimization": "Optimization",
  "campaignDetails.creative": "Creative",
  "campaignDetails.callToAction": "Call to Action",
  "campaignDetails.associatedProducts": "Associated Products",

  // ── campaignModal ──
  "campaignModal.refLabel": "Reference (Ref) *",
  "campaignModal.refPlaceholder": "shade_net_2025",
  "campaignModal.refHint": "URL: ?ref=value",
  "campaignModal.nameRequired": "Name *",
  "campaignModal.namePlaceholderExample": "Agricultural Shade Net",
  "campaignModal.trafficSource": "Traffic Source",
  "campaignModal.conversationGoal": "Conversation Goal",
  "campaignModal.activeCheckbox": "Active",
  "campaignModal.startDateLabel": "Start Date",
  "campaignModal.endDateLabel": "End Date",
  "campaignModal.initialMessage": "Initial Message",
  "campaignModal.initialMessagePlaceholder": "Hi! I see you're interested in shade nets...",
  "campaignModal.adAngle": "Ad Angle",
  "campaignModal.selectOption": "Select...",
  "campaignModal.adSummary": "Ad Summary",
  "campaignModal.adSummaryPlaceholder": "Sun protection to prevent crop sunburn",
  "campaignModal.adSummaryHint": "Brief description of the ad message",
  "campaignModal.ctaLabel": "Call to Action (CTA)",
  "campaignModal.offerHook": "Offer/Hook",
  "campaignModal.audienceType": "Audience Type",
  "campaignModal.experienceLevel": "Experience Level",
  "campaignModal.audienceNoteTitle": "Note about audience",
  "campaignModal.audienceNoteText": "The audience type helps the bot adjust tone and recommendations. For example, a farmer gets technical info while a homeowner gets practical tips.",
  "campaignModal.productsTitle": "Campaign Products",
  "campaignModal.productsHint": "Select the products available in this campaign",
  "campaignModal.responseTone": "Response Tone",
  "campaignModal.mustNot": "The bot MUST NOT...",
  "campaignModal.selectRule": "Select rule...",
  "campaignModal.shouldDo": "The bot SHOULD...",
  "campaignModal.catalogSaveFirst": "Save the campaign first to upload a catalog.",
  "campaignModal.catalogNoteTitle": "Note about catalogs",
  "campaignModal.catalogNoteText": "The catalog uploaded here will be available for all AdSets and Ads of this campaign, unless a specific catalog is uploaded at the AdSet or Ad level.",
  "campaignModal.fbAdAccountId": "FB Ad Account ID",
  "campaignModal.objectiveLabel": "Objective",
  "campaignModal.dailyBudget": "Daily Budget ($)",
  "campaignModal.lifetimeBudget": "Lifetime Budget ($)",
  "campaignModal.statusActive": "Active",
  "campaignModal.statusPaused": "Paused",
  "campaignModal.statusArchived": "Archived",
  "campaignModal.objectiveTraffic": "Traffic",
  "campaignModal.objectiveLeads": "Leads",
  "campaignModal.objectiveSales": "Sales",
  "campaignModal.objectiveEngagement": "Engagement",
  "campaignModal.update": "Update",
  "campaignModal.tabBasic": "Basic",
  "campaignModal.tabAd": "Ad",
  "campaignModal.tabAudience": "Audience",
  "campaignModal.tabProducts": "Products",
  "campaignModal.tabGuidelines": "AI Guidelines",
  "campaignModal.tabCatalog": "Catalog",
  "campaignModal.tabFacebook": "Facebook",
  "campaignModal.offerHookPlaceholder": "20% off + free shipping",
  "campaignModal.goalQuote": "Quote",
  "campaignModal.goalDirectSale": "Direct Sale",
  "campaignModal.goalLeadCapture": "Lead Capture",
  "campaignModal.goalInfo": "Information",
  "campaignModal.refRequired": "Please enter a value for the Ref field",

  // ── campaignProductModal ──
  "campaignProductModal.editTitle": "Edit Campaign Product",
  "campaignProductModal.newTitle": "New Campaign Product",
  "campaignProductModal.productLabel": "Product *",
  "campaignProductModal.selectProduct": "Select product...",
  "campaignProductModal.campaignLabel": "Campaign *",
  "campaignProductModal.selectCampaign": "Select campaign...",
  "campaignProductModal.shadeLabel": "Shade",
  "campaignProductModal.colorLabel": "Color",
  "campaignProductModal.customPrice": "Custom Price",
  "campaignProductModal.addVariant": "Add Variant",
  "campaignProductModal.removeVariant": "Remove variant",
  "campaignProductModal.variant": "Variant",
  "campaignProductModal.size": "Size",
  "campaignProductModal.variantPrice": "Price",
  "campaignProductModal.activeCheckbox": "Active",
  "campaignProductModal.cancel": "Cancel",
  "campaignProductModal.create": "Create",
  "campaignProductModal.update": "Update",
  "campaignProductModal.errorRequired": "Please fill in product and campaign",
  "campaignProductModal.errorSave": "Error saving campaign product",
  "campaignProductModal.savedSuccess": "Campaign product saved",
  "campaignProductModal.shade": "Shade:",
  "campaignProductModal.color": "Color:",
  "campaignProductModal.variantCount": "variant(s)",
  "campaignProductModal.campaignRef": "Campaign Reference *",
  "campaignProductModal.cantChange": "Cannot change after creating",
  "campaignProductModal.productName": "Product Name *",
  "campaignProductModal.shortName": "Short Name",
  "campaignProductModal.features": "Features",
  "campaignProductModal.addFeature": "Add",
  "campaignProductModal.variants": "Variants",
  "campaignProductModal.sizePlaceholder": "Size (e.g.: 4x6m)",
  "campaignProductModal.pricePlaceholder": "Price",
  "campaignProductModal.sourceLocal": "Local",
  "campaignProductModal.sourceML": "Mercado Libre",
  "campaignProductModal.linkPlaceholder": "Purchase link",
  "campaignProductModal.inStock": "In stock",
  "campaignProductModal.outOfStock": "Out of stock",
  "campaignProductModal.fallbackMessage": "Fallback Message",
  "campaignProductModal.suggestClosest": "Suggest closest alternatives",
  "campaignProductModal.active": "Active",
  "campaignProductModal.updateProduct": "Update Product",
  "campaignProductModal.createProduct": "Create Product",

  // ── campaignProducts ──
  "campaignProducts.newProduct": "New Campaign Product",
  "campaignProducts.listTitle": "Campaign Product List",
  "campaignProducts.loading": "Loading campaign products...",
  "campaignProducts.product": "Product",
  "campaignProducts.campaign": "Campaign",
  "campaignProducts.details": "Details",
  "campaignProducts.variants": "Variants",
  "campaignProducts.status": "Status",
  "campaignProducts.actions": "Actions",
  "campaignProducts.active": "Active",
  "campaignProducts.inactive": "Inactive",
  "campaignProducts.subtitle": "Manage products associated with each campaign",
  "campaignProducts.emptyDescription": "Start by adding your first campaign product",
  "campaignProducts.addProductButton": "Add Campaign Product",
  "campaignProducts.headerProduct": "Product",
  "campaignProducts.headerCampaign": "Campaign",
  "campaignProducts.headerDetails": "Details",
  "campaignProducts.headerVariants": "Variants",
  "campaignProducts.shade": "Shade:",
  "campaignProducts.color": "Color:",
  "campaignProducts.variantCount": "variant(s)",

  // ── campaignsView ──
  "campaignsView.title": "Campaigns",
  "campaignsView.newCampaign": "New Campaign",
  "campaignsView.loading": "Loading campaigns...",
  "campaignsView.noCampaigns": "No campaigns",
  "campaignsView.active": "Active",
  "campaignsView.inactive": "Inactive",
  "campaignsView.details": "Campaign Details",
  "campaignsView.basicInfo": "Basic Info",
  "campaignsView.fbConfig": "Facebook Configuration",
  "campaignsView.budget": "Budget",
  "campaignsView.dates": "Dates",
  "campaignsView.botConfig": "Bot Configuration",
  "campaignsView.metrics": "Metrics",
  "campaignsView.ref": "Ref",
  "campaignsView.trafficSource": "Traffic Source",
  "campaignsView.conversationGoal": "Conversation Goal",
  "campaignsView.responseTone": "Response Tone",
  "campaignsView.adAngle": "Ad Angle",
  "campaignsView.cta": "CTA",
  "campaignsView.offerHook": "Offer/Hook",
  "campaignsView.initialMessage": "Initial Message",
  "campaignsView.fbCampaignId": "FB Campaign ID",
  "campaignsView.fbAdAccountId": "FB Ad Account ID",
  "campaignsView.objective": "Objective",
  "campaignsView.dailyBudget": "Daily Budget",
  "campaignsView.lifetimeBudget": "Lifetime Budget",
  "campaignsView.startDate": "Start Date",
  "campaignsView.endDate": "End Date",
  "campaignsView.notSet": "Not set",
  "campaignsView.impressions": "Impressions",
  "campaignsView.clicks": "Clicks",
  "campaignsView.spend": "Spend",
  "campaignsView.conversions": "Conversions",
  "campaignsView.close": "Close",
  "campaignsView.createdAt": "Created",
  "campaignsView.updatedAt": "Updated",
  "campaignsView.noData": "No data",
  "campaignsView.audienceType": "Audience Type",
  "campaignsView.experienceLevel": "Experience Level",
  "campaignsView.subtitle": "Manage Facebook/Instagram campaigns",
  "campaignsView.campaignList": "Campaign List",
  "campaignsView.loadingCampaigns": "Loading campaigns...",
  "campaignsView.startCreating": "Start by creating your first campaign",
  "campaignsView.addCampaign": "Add Campaign",
  "campaignsView.thName": "Name",
  "campaignsView.thStatus": "Status",
  "campaignsView.thMetrics": "Metrics",
  "campaignsView.thDates": "Dates",
  "campaignsView.thActions": "Actions",
  "campaignsView.detailsTitle": "Campaign Details",
  "campaignsView.reference": "Reference",
  "campaignsView.daily": "Daily",
  "campaignsView.totalBudget": "Total",
  "campaignsView.defaultFlow": "Default Flow",
  "campaignsView.conversionGoal": "Conversion Goal",
  "campaignsView.productFocus": "Product Focus",
  "campaignsView.metricsTitle": "Metrics",
  "campaignsView.visits": "Visits",
  "campaignsView.interactions": "Interactions",
  "campaignsView.leads": "Leads",
  "campaignsView.internalId": "Internal ID",
  "campaignsView.statusFb": "FB Status",

  // ── catalogUpload ──
  "catalogUpload.onlyPdf": "Only PDF files are allowed",
  "catalogUpload.maxSize": "File cannot be larger than 10MB",
  "catalogUpload.useExisting": "Use existing catalog...",
  "catalogUpload.orUploadNew": "or upload new:",
  "catalogUpload.replaceCatalog": "Replace catalog",
  "catalogUpload.uploadCatalog": "Upload PDF catalog",
  "catalogUpload.dropzone": "Drag or click to select (max. 10MB)",
  "catalogUpload.viewCatalog": "View catalog",
  "catalogUpload.deleteCatalog": "Delete catalog",
  "catalogUpload.confirmDelete": "Delete this catalog?",
  "catalogUpload.inheritedFrom": "Inherited from: {{source}}",
  "catalogUpload.overrideHint": "Upload your own catalog to override inherited one",
  "catalogUpload.errorUpload": "Error uploading catalog",
  "catalogUpload.errorDelete": "Error deleting catalog",
  "catalogUpload.pdfLabel": "PDF Catalog",
  "catalogUpload.cover": "Cover",
  "catalogUpload.uploaded": "Uploaded: {{date}}",
  "catalogUpload.uploadingCatalog": "Uploading catalog...",
  "catalogUpload.uploadPdf": "Upload PDF catalog",
  "catalogUpload.dragOrClick": "Drag or click to select (max. 10MB)",
  "catalogUpload.overrideInherited": "Upload your own catalog to override the inherited one",

  // ── clickLogs ──
  "clickLogs.subtitle": "Analytics for tracked links shared with users",
  "clickLogs.totalLinks": "Total Links",
  "clickLogs.clicks": "Clicks",
  "clickLogs.conversions": "Conversions",
  "clickLogs.uniqueUsers": "Unique Users",
  "clickLogs.chartTitle": "Links and Clicks by Day",
  "clickLogs.chartLinks": "Links",
  "clickLogs.chartClicks": "Clicks",
  "clickLogs.filters": "Filters",
  "clickLogs.startDate": "Start Date",
  "clickLogs.endDate": "End Date",
  "clickLogs.clickStatus": "Click Status",
  "clickLogs.conversionStatus": "Conversion Status",
  "clickLogs.clicked": "Clicked",
  "clickLogs.notClicked": "Not clicked",
  "clickLogs.topProduct": "Most popular product",
  "clickLogs.topDay": "Most active day",
  "clickLogs.handovers": "Handovers",
  "clickLogs.topAd": "Top ad",
  "clickLogs.loading": "Loading logs...",
  "clickLogs.noLogsMessage": "No trackable links have been generated yet",
  "clickLogs.link": "Link",
  "clickLogs.product": "Product",
  "clickLogs.created": "Created",
  "clickLogs.clickedAt": "Clicked",
  "clickLogs.status": "Status",
  "clickLogs.statusClick": "Click",
  "clickLogs.statusPending": "Pending",
  "clickLogs.statusSale": "Sale",
  "clickLogs.transferredConversions": "Transferred conversions",
  "clickLogs.errorLoad": "Error loading click logs",
  "clickLogs.ad": "Ad",
  "clickLogs.campaign": "Campaign",
  "clickLogs.none": "None",
  "clickLogs.user": "User",
  "clickLogs.date": "Date",
  "clickLogs.noData": "No data",
  "clickLogs.titleFull": "Click Logs",
  "clickLogs.ofLinks": "links",
  "clickLogs.ofClicks": "clicks",
  "clickLogs.conversionsLabel": "Conversions",
  "clickLogs.dailyChart": "Links and Clicks by Day",
  "clickLogs.filterAll": "All",
  "clickLogs.filterClicked": "Clicked",
  "clickLogs.filterNotClicked": "Not clicked",
  "clickLogs.filterConverted": "Converted",
  "clickLogs.filterNotConverted": "Not converted",
  "clickLogs.busiestDay": "Most active day",
  "clickLogs.handoversDescription": "Transferred conversations",
  "clickLogs.noAdName": "(unnamed)",
  "clickLogs.noAdData": "No ad data",
  "clickLogs.noRecords": "No records",
  "clickLogs.noRecordsDescription": "No trackable links have been generated yet",
  "clickLogs.headerPsid": "PSID",
  "clickLogs.headerLink": "Link",
  "clickLogs.headerProduct": "Product",
  "clickLogs.headerCreated": "Created",
  "clickLogs.headerClicked": "Clicked",
  "clickLogs.headerStatus": "Status",
  "clickLogs.statusSaleApprox": "Sale~",
  "clickLogs.errorLoadStats": "Error loading statistics",
  "clickLogs.errorLoadLogs": "Error loading click logs",

  // ── copyProduct ──
  "copyProduct.sourceName": "Source",
  "copyProduct.newName": "New Name *",
  "copyProduct.namePlaceholder": "Name for the copy",
  "copyProduct.copyChildren": "Copy children",
  "copyProduct.copyChildrenHint": "Also copy all child products recursively",
  "copyProduct.copyDimensions": "Copy dimension values",
  "copyProduct.copySellable": "Copy sellable details",
  "copyProduct.cancel": "Cancel",
  "copyProduct.success": "Product copied successfully",
  "copyProduct.error": "Error copying product",
  "copyProduct.childrenCount": "{{count}} children will also be copied",
  "copyProduct.sameParent": "Same parent (sibling)",
  "copyProduct.copyLinks": "Copy store links",
  "copyProduct.copyCatalog": "Copy catalog",
  "copyProduct.selectChildrenDesc": "Select which children to copy along with the product",
  "copyProduct.selectParent": "Select Parent for Copied Product",
  "copyProduct.loadingFamilies": "Loading families...",
  "copyProduct.noFamilies": "No families available",
  "copyProduct.parentHelp": "Click a family to select it as the parent of the copied product. Sellable products cannot have children.",
  "copyProduct.noChildren": "This product has no children. Only the product itself will be copied.",
  "copyProduct.selectedCount": "{{selected}} of {{total}} selected",
  "copyProduct.selectAllBtn": "Select All",
  "copyProduct.deselectAllBtn": "Deselect All",
  "copyProduct.sellableLabel": "Sellable",
  "copyProduct.childrenCopied": "{{count}} child(ren) - will also be copied",
  "copyProduct.copyProduct": "Copy Product",
  "copyProduct.copyWithChildren": "Copy with {{count}} child(ren)",
  "copyProduct.copyOnly": "Copy Product Only",
  "copyProduct.cannotHaveChildren": "(Cannot have children)",
  "copyProduct.selectParentAlert": "Please select a parent for the copied product",
  "copyProduct.errorLoadFamilies": "Error loading available families",

  // ── familyModal ──
  "familyModal.editTitle": "Edit Product Family",
  "familyModal.newTitle": "New Product Family",
  "familyModal.nameRequired": "Name *",
  "familyModal.specifications": "Specifications",
  "familyModal.specificationsPlaceholder": "Technical product specifications (dimensions, materials, features, etc.)...",
  "familyModal.marketingDescription": "Marketing Description",
  "familyModal.marketingHint": "Promotional content to be used in marketing campaigns",
  "familyModal.parentProduct": "Parent Product",
  "familyModal.noParent": "None (Root Product)",
  "familyModal.parentHint": "Select a parent to create a child product in the family tree",
  "familyModal.enabledDimensions": "Enabled Dimensions",
  "familyModal.dimensionsHint": "Select the dimensions to be used for this product. Child products will inherit all dimensions.",
  "familyModal.dimensionsCount": "{{count}} dimension(s) enabled. All child products will have these dimensions.",
  "familyModal.dimensionValues": "Dimension Values",
  "familyModal.importDimensions": "Import",
  "familyModal.dimensionValuesHint": "These values are optional and can be inherited by child products",
  "familyModal.sellableCheckbox": "This product is sellable (can be offered in campaigns)",
  "familyModal.rootNotSellable": "Root products cannot be sellable. Select a parent product first.",
  "familyModal.price": "Price",
  "familyModal.priceHint": "Non-sellable products can have a price to apply to all their children",
  "familyModal.wholesaleEnabled": "Wholesale enabled",
  "familyModal.wholesaleHint": "Allows special pricing by quantity",
  "familyModal.minQuantity": "Min Quantity",
  "familyModal.wholesalePrice": "Wholesale Price",
  "familyModal.productCatalog": "Product Catalog",
  "familyModal.catalogHint": "This catalog will be used as a fallback for all child products",
  "familyModal.sellableDetails": "Sellable Product Details",
  "familyModal.sku": "SKU",
  "familyModal.stock": "Inventory",
  "familyModal.botQuerySize": "Size (Bot Query)",
  "familyModal.thumbnail": "Thumbnail",
  "familyModal.onlineStoreLinks": "Online Store Links",
  "familyModal.importMLLink": "Import Mercado Libre Link",
  "familyModal.searchingLink": "Searching link for:",
  "familyModal.addLink": "Add link",
  "familyModal.importFromProducts": "Import from Products",
  "familyModal.selectStore": "Select store",
  "familyModal.primaryLink": "Primary",
  "familyModal.withLink": "With Link",
  "familyModal.withoutLink": "Without Link",
  "familyModal.clearDimension": "Clear dimension value",
  "familyModal.cancel": "Cancel",
  "familyModal.create": "Create Product Family",
  "familyModal.update": "Update Product Family",
  "familyModal.errorDimensionImport": "Error importing dimensions",
  "familyModal.openLinkNewTab": "Open link in new tab",
  "familyModal.searchProducts": "Search by name, size or description...",
  "familyModal.dimensionWidth": "Width",
  "familyModal.dimensionLength": "Length",
  "familyModal.dimensionHeight": "Height",
  "familyModal.dimensionDepth": "Depth",
  "familyModal.dimensionThickness": "Thickness",
  "familyModal.dimensionWeight": "Weight",
  "familyModal.dimensionDiameter": "Diameter",
  "familyModal.dimensionSide1": "Side 1",
  "familyModal.dimensionSide2": "Side 2",
  "familyModal.dimensionSide3": "Side 3",
  "familyModal.dimensionSide4": "Side 4",
  "familyModal.dimensionSide5": "Side 5",
  "familyModal.dimensionSide6": "Side 6",
  "familyModal.saveCatalogFirst": "Save the product family first to upload a catalog.",
  "familyModal.requiresAdvisor": "Requires human advisor for sales",
  "familyModal.requiresAdvisorHint": "If enabled, the bot will always transfer to a human for this product",
  "familyModal.wholesaleMinQty": "Minimum quantity",
  "familyModal.wholesaleMinHint": "Minimum for wholesale pricing",
  "familyModal.wholesalePriceHint": "Price per unit wholesale",
  "familyModal.catalogTitle": "Product Catalog",
  "familyModal.sizeLabel": "Size (Bot Query)",
  "familyModal.sizeAutoGenerated": "(Auto-generated)",
  "familyModal.sizeHint": "Automatically extracted from product name. You can modify it manually if needed.",
  "familyModal.productDimensions": "Product Dimensions",
  "familyModal.inherited": "(Inherited)",
  "familyModal.dimensionsAutoHint": "These dimensions are used to auto-generate the Size field",
  "familyModal.genericDescription": "Generic Description (Cross-Selling)",
  "familyModal.genericDescHint": "Brief description shown when the customer asks about this product",
  "familyModal.requiresHumanAdvisor": "Requires human advisor",
  "familyModal.requiresHumanHint": "When checked, the bot will offer to connect the customer with a human advisor when asking about this product",
  "familyModal.thumbnailHint": "Product thumbnail image URL",
  "familyModal.preferred": "Primary",
  "familyModal.linksHint": "Add links manually or import Mercado Libre link from existing products",
  "familyModal.updateFamily": "Update Product Family",
  "familyModal.createFamily": "Create Product Family",
  "familyModal.searchingFor": "Searching link for: ",
  "familyModal.productsAvailable": "{{count}} products available",
  "familyModal.productsFound": "{{count}} found",
  "familyModal.searchPlaceholder": "Search by name, size or description...",
  "familyModal.loadingProducts": "Loading products...",
  "familyModal.noProductsFound": "No products found matching that criteria",
  "familyModal.noProductsAvailable": "No products available",
  "familyModal.noLinkLabel": "No Link",
  "familyModal.openLink": "Open link in new tab",
  "familyModal.noInheritedDimensions": "No inherited dimensions to import",

  // ── familyTree ──
  "familyTree.collapse": "Collapse",
  "familyTree.expand": "Expand",
  "familyTree.sellable": "Sellable",
  "familyTree.noLink": "No Link",
  "familyTree.noDimensions": "No Dimensions",
  "familyTree.inventory": "Inventory:",
  "familyTree.addChild": "Add Child",
  "familyTree.noChildrenSellable": "Sellable products cannot have children",
  "familyTree.copySibling": "Copy as Sibling",
  "familyTree.noImportSellable": "Sellable products cannot import children",
  "familyTree.importProducts": "Import Products",
  "familyTree.viewDetails": "View Details",
  "familyTree.edit": "Edit",
  "familyTree.delete": "Delete",
  "familyTree.title": "Product Families",
  "familyTree.subtitle": "Manage product family trees with parent-child generational relationships",
  "familyTree.newFamily": "New Product Family",
  "familyTree.globalCatalog": "Global Catalog",
  "familyTree.globalCatalogDesc": "Used when no catalog exists at the ad, campaign, or product family level",
  "familyTree.treeTitle": "Product Family Tree",
  "familyTree.treeSubtitle": "Expandable tree view showing product generations. Only sellable products can be offered in campaigns.",
  "familyTree.loadingFamilies": "Loading product families...",
  "familyTree.noFamilies": "No product families found",
  "familyTree.startAdding": "Start by adding your first product family",
  "familyTree.addFamily": "Add Product Family",
  "familyTree.viewDetailsTooltip": "View details",
  "familyTree.requiresAdvisor": "Requires human advisor",
  "familyTree.noLinkTooltip": "Product without online store link",
  "familyTree.noDimensionsTooltip": "Product with missing or zero dimensions",

  // ── flowModal ──
  "flowModal.editTitle": "Edit Flow",
  "flowModal.newTitle": "New Flow",
  "flowModal.tabBasic": "Basic",
  "flowModal.tabSteps": "Steps",
  "flowModal.tabOnComplete": "On Complete",
  "flowModal.keyLabel": "Key (identifier) *",
  "flowModal.keyPlaceholder": "distributor_inquiry",
  "flowModal.nameLabel": "Name *",
  "flowModal.descriptionLabel": "Description",
  "flowModal.descriptionPlaceholder": "Flow description",
  "flowModal.triggerIntentLabel": "Trigger Intent",
  "flowModal.selectIntent": "Select intent...",
  "flowModal.activeCheckbox": "Active",
  "flowModal.stepsTitle": "Flow Steps",
  "flowModal.stepNumber": "Step {{n}}",
  "flowModal.removeStep": "Remove step",
  "flowModal.questionLabel": "Question/Message *",
  "flowModal.questionPlaceholder": "What is your name?",
  "flowModal.variableName": "Variable Name",
  "flowModal.variablePlaceholder": "customer_name",
  "flowModal.inputType": "Input Type",
  "flowModal.typeFreeText": "Free text",
  "flowModal.typeOptions": "Options",
  "flowModal.typeNumber": "Number",
  "flowModal.typePhone": "Phone",
  "flowModal.typeEmail": "Email",
  "flowModal.typeConfirmation": "Confirmation (Yes/No)",
  "flowModal.options": "Options",
  "flowModal.addOption": "Add option",
  "flowModal.removeOption": "Remove",
  "flowModal.requiredStep": "Required",
  "flowModal.onCompleteTitle": "On Complete Action",
  "flowModal.actionSendMessage": "Send message",
  "flowModal.actionHandoff": "Transfer to human",
  "flowModal.actionTriggerFlow": "Start another flow",
  "flowModal.actionTriggerIntent": "Trigger intent",
  "flowModal.completionMessage": "Completion Message",
  "flowModal.completionPlaceholder": "Thanks for the info. An advisor will contact you soon.",
  "flowModal.handoffReason": "Handoff Reason",
  "flowModal.handoffPlaceholder": "Interested in being a distributor",
  "flowModal.includeVariables": "Include collected variables in handoff",
  "flowModal.targetFlow": "Target Flow",
  "flowModal.targetIntent": "Target Intent",
  "flowModal.save": "Save Changes",
  "flowModal.cancel": "Cancel",
  "flowModal.errorKeyName": "Please fill in the key and name",
  "flowModal.errorMinSteps": "The flow must have at least one step",
  "flowModal.inputTypeText": "Free text",
  "flowModal.inputTypeOptions": "Options",
  "flowModal.inputTypeNumber": "Number",
  "flowModal.inputTypePhone": "Phone",
  "flowModal.inputTypeEmail": "Email",
  "flowModal.inputTypeConfirm": "Confirmation (Yes/No)",
  "flowModal.actionMessage": "Send message",
  "flowModal.actionFlow": "Start another flow",
  "flowModal.actionIntent": "Trigger intent",
  "flowModal.basicTab": "Basic",
  "flowModal.stepsTab": "Steps",
  "flowModal.completeTab": "On Complete",
  "flowModal.nameRequired": "Name *",
  "flowModal.description": "Description",
  "flowModal.noTrigger": "None (manual)",
  "flowModal.triggerNote": "Only intents with handlerType=flow are shown",
  "flowModal.timeout": "Timeout (minutes)",
  "flowModal.flowActive": "Flow active",
  "flowModal.noStepsDefined": "No steps defined",
  "flowModal.addFirstStep": "Add first step",
  "flowModal.stepNoMessage": "Step without message",
  "flowModal.botMessage": "Bot message *",
  "flowModal.saveResponseAs": "Save response as",
  "flowModal.responseType": "Response type",
  "flowModal.optionLabel": "Label",
  "flowModal.optionValue": "Value",
  "flowModal.nextStep": "Next step",
  "flowModal.completeFlow": "Complete flow",
  "flowModal.nextInOrder": "Next in order",
  "flowModal.stepPrefix": "Step",
  "flowModal.addStepButton": "+ Add step",
  "flowModal.completeAction": "Action on complete",
  "flowModal.finalMessage": "Final message",
  "flowModal.handoffVariables": "Variables to include in handoff",
  "flowModal.nextFlowLabel": "Next flow",
  "flowModal.triggerIntentSelect": "Intent to trigger",
  "flowModal.saveChanges": "Save Changes",
  "flowModal.createFlow": "Create Flow",
  "flowModal.errorNoSteps": "The flow must have at least one step",

  // ── flows ──
  "flows.newFlow": "New Flow",
  "flows.loading": "Loading flows...",
  "flows.confirmDelete": "Are you sure you want to delete this flow?",
  "flows.flowCreated": "Flow created successfully",
  "flows.flowUpdated": "Flow updated successfully",
  "flows.flowDeleted": "Flow deleted successfully",
  "flows.errorLoad": "Error loading flows",
  "flows.errorSave": "Error saving flow",
  "flows.errorDelete": "Error deleting flow",
  "flows.key": "Key",
  "flows.status": "Status",
  "flows.actions": "Actions",
  "flows.active": "Active",
  "flows.inactive": "Inactive",
  "flows.stepsCount": "{{count}} steps",
  "flows.noTrigger": "No trigger",
  "flows.description": "Description",
  "flows.details": "Flow Details",
  "flows.close": "Close",
  "flows.onComplete": "On Complete",
  "flows.completionAction": "Action",
  "flows.completionMessage": "Message",
  "flows.handoffReason": "Reason",
  "flows.subtitle": "Define step-by-step conversational flows to collect information",
  "flows.searchPlaceholderFull": "Search by name, key or intent...",
  "flows.filterAll": "All",
  "flows.filterActive": "Active",
  "flows.filterInactive": "Inactive",
  "flows.noMatchingFlows": "No flows match your search",
  "flows.createFirstFlow": "Create first flow",
  "flows.triggerLabel": "Trigger:",
  "flows.stepsLabel": "Steps:",
  "flows.noSteps": "No steps",
  "flows.onCompleteHandoff": "Handoff",
  "flows.onCompleteFlow": "Another flow",
  "flows.onCompleteIntent": "Intent",
  "flows.onCompleteMessage": "Message",
  "flows.started": "started",
  "flows.completed": "completed",
  "flows.errorSaveFlow": "Error saving flow",
  "flows.errorDeleteFlow": "Error deleting flow",
  "flows.editButton": "Edit",
  "flows.deleteButton": "Delete",

  // ── grupos ──
  "grupos.subtitle": "Manage groups of related products (bundles, complementary, alternatives)",
  "grupos.newGrupo": "New Group",
  "grupos.loading": "Loading groups...",
  "grupos.noGruposRegistered": "No groups registered",
  "grupos.startAdding": "Start by adding the first product group",
  "grupos.typeBundle": "Bundle",
  "grupos.typeComplementary": "Complementary",
  "grupos.typeAlternative": "Alternative",
  "grupos.type": "Type",
  "grupos.products": "Products",
  "grupos.status": "Status",
  "grupos.actions": "Actions",
  "grupos.active": "Active",
  "grupos.inactive": "Inactive",
  "grupos.confirmDelete": "Are you sure you want to delete this group?",
  "grupos.deletedSuccess": "Group deleted successfully",
  "grupos.loadingGrupos": "Loading groups...",
  "grupos.typeSeasonal": "Seasonal",
  "grupos.typeCustom": "Custom",
  "grupos.inactiveLabel": "Inactive",
  "grupos.productsCount": "{{count}} products",
  "grupos.priorityLabel": "Priority: {{value}}",
  "grupos.discountLabel": "{{value}}% discount",
  "grupos.productsIncluded": "Products included:",
  "grupos.moreProducts": "+{{count}} more...",
  "grupos.editTooltip": "Edit",
  "grupos.deleteTooltip": "Delete",

  // ── gruposModal ──
  "gruposModal.editTitle": "Edit Group",
  "gruposModal.newTitle": "New Group",
  "gruposModal.nameRequired": "Name *",
  "gruposModal.namePlaceholder": "Shade net accessories",
  "gruposModal.descriptionLabel": "Description",
  "gruposModal.descriptionPlaceholder": "Product group description...",
  "gruposModal.typeLabel": "Group Type *",
  "gruposModal.typeBundle": "Bundle",
  "gruposModal.typeComplementary": "Complementary",
  "gruposModal.typeAlternative": "Alternative",
  "gruposModal.productsTitle": "Products in Group",
  "gruposModal.addProduct": "Add Product",
  "gruposModal.removeProduct": "Remove",
  "gruposModal.selectProduct": "Select product...",
  "gruposModal.noProducts": "No products added",
  "gruposModal.addProductHint": "Add products that belong to this group",
  "gruposModal.activeCheckbox": "Active",
  "gruposModal.cancel": "Cancel",
  "gruposModal.update": "Update Group",
  "gruposModal.errorRequired": "Please fill in the name and type",
  "gruposModal.errorSave": "Error saving group",
  "gruposModal.savedSuccess": "Group saved successfully",
  "gruposModal.productName": "Product",
  "gruposModal.quantity": "Quantity",
  "gruposModal.optional": "Optional",
  "gruposModal.required": "Required",
  "gruposModal.displayOrder": "Order",
  "gruposModal.notes": "Notes",
  "gruposModal.basicInfo": "Basic Info",
  "gruposModal.description": "Description",
  "gruposModal.groupType": "Group Type *",
  "gruposModal.typeBundleDesc": "Products that go well together",
  "gruposModal.typeComplementaryDesc": "Products that complement each other",
  "gruposModal.typeAlternativeDesc": "Alternatives for the same use case",
  "gruposModal.typeSeasonalDesc": "Seasonal groupings",
  "gruposModal.typeCustomDesc": "Custom grouping",
  "gruposModal.imageUrl": "Image URL",
  "gruposModal.priorityAndDiscounts": "Priority & Discounts",
  "gruposModal.priorityLabel": "Priority: {{value}}",
  "gruposModal.priorityLow": "Low (1)",
  "gruposModal.priorityHigh": "High (10)",
  "gruposModal.discount": "Discount (%)",
  "gruposModal.discountHint": "Discount when purchasing products from the group",
  "gruposModal.available": "Group available",
  "gruposModal.tags": "Tags",
  "gruposModal.addTagPlaceholder": "Add tag...",
  "gruposModal.addTag": "Add",
  "gruposModal.groupProducts": "Group Products",
  "gruposModal.groupProductsHint": "Select products that belong to this group. You can expand categories to see specific products.",
  "gruposModal.suggestedProducts": "Suggested Products (Optional)",
  "gruposModal.suggestedProductsHint": "Recommended products when this group is shown. You can expand categories to see specific products.",
  "gruposModal.updateGrupo": "Update Group",
  "gruposModal.createGrupo": "Create Group",

  // ── importProducts ──
  "importProducts.subtitle": "Import products into {{name}}",
  "importProducts.source": "Source",
  "importProducts.selectSource": "Select source...",
  "importProducts.fromExisting": "From existing products",
  "importProducts.fromCSV": "From CSV file",
  "importProducts.selectProducts": "Select products to import",
  "importProducts.loading": "Loading...",
  "importProducts.noProducts": "No products available",
  "importProducts.import": "Import",
  "importProducts.cancel": "Cancel",
  "importProducts.count": "{{count}} products selected",
  "importProducts.searchPlaceholder": "Search products...",
  "importProducts.selectAll": "Select all",
  "importProducts.titleFromProducts": "Import Products from Products",
  "importProducts.selectOrphan": "Select orphan products (without family) to import into the family",
  "importProducts.loadingProducts": "Loading products...",
  "importProducts.selectedCount": "{{selected}} of {{total}} selected",
  "importProducts.priceLabel": "Price:",
  "importProducts.selectedProducts": "{{count}} product selected",
  "importProducts.selectedProductsPlural": "{{count}} products selected",
  "importProducts.importingBtn": "Importing...",
  "importProducts.importCount": "Import {{count}} product",
  "importProducts.importCountPlural": "Import {{count}} products",
  "importProducts.selectAtLeast": "Please select at least one product",
  "importProducts.successCount": "{{count}} products imported successfully",
  "importProducts.errorImport": "Error importing products: ",
  "importProducts.errorLoad": "Error loading products",

  // ── intentCategoryModal ──
  "intentCategoryModal.editTitle": "Edit Category",
  "intentCategoryModal.newTitle": "New Category",
  "intentCategoryModal.keyLabel": "Key (identifier) *",
  "intentCategoryModal.keyPlaceholder": "sales_intents",
  "intentCategoryModal.nameLabel": "Name *",
  "intentCategoryModal.descriptionLabel": "Description",
  "intentCategoryModal.colorLabel": "Color",
  "intentCategoryModal.colorHint": "Color for visual identification",
  "intentCategoryModal.iconLabel": "Icon (Emoji)",
  "intentCategoryModal.iconPlaceholder": "Select icon...",
  "intentCategoryModal.activeCheckbox": "Active",
  "intentCategoryModal.save": "Save Changes",
  "intentCategoryModal.cancel": "Cancel",
  "intentCategoryModal.errorKeyName": "Please fill in the key and name",
  "intentCategoryModal.preview": "Preview",
  "intentCategoryModal.orderLabel": "Order",
  "intentCategoryModal.orderHint": "Display order (lower numbers appear first)",
  "intentCategoryModal.selectColor": "Select a color",
  "intentCategoryModal.noColor": "No color",
  "intentCategoryModal.keyRequired": "Key (identifier) *",
  "intentCategoryModal.nameRequired": "Name *",
  "intentCategoryModal.color": "Color",
  "intentCategoryModal.order": "Order",
  "intentCategoryModal.saveChanges": "Save Changes",
  "intentCategoryModal.createCategory": "Create Category",
  "intentCategoryModal.alertKeyName": "Please fill in the key and name",
  "intentCategoryModal.alertKeyFormat": "Key can only contain lowercase letters, numbers and underscores",
  "intentCategoryModal.colorGreen": "Green",
  "intentCategoryModal.colorBlue": "Blue",
  "intentCategoryModal.colorPurple": "Purple",
  "intentCategoryModal.colorOrange": "Orange",
  "intentCategoryModal.colorRed": "Red",
  "intentCategoryModal.colorGray": "Gray",
  "intentCategoryModal.colorPink": "Pink",
  "intentCategoryModal.colorTeal": "Teal",

  // ── intentModal ──
  "intentModal.editTitle": "Edit Intent",
  "intentModal.newTitle": "New Intent",
  "intentModal.tabBasic": "Basic",
  "intentModal.tabClassification": "Classification",
  "intentModal.tabResponse": "Response",
  "intentModal.tabStats": "Stats",
  "intentModal.keyLabel": "Key (identifier) *",
  "intentModal.keyPlaceholder": "product_inquiry",
  "intentModal.nameLabel": "Name *",
  "intentModal.categoryLabel": "Category",
  "intentModal.noCategory": "No category",
  "intentModal.priorityLabel": "Priority",
  "intentModal.priorityLow": "Low",
  "intentModal.priorityHigh": "High",
  "intentModal.activeCheckbox": "Active",
  "intentModal.examplePhrases": "Example Phrases",
  "intentModal.examplePhrasesHint": "Phrases that users might say to trigger this intent (one per line)",
  "intentModal.examplePlaceholder": "How much does the shade net cost?\nWhat sizes do you have?\nI need a price list",
  "intentModal.keywords": "Keywords",
  "intentModal.keywordsHint": "Keywords to help classification (one per line)",
  "intentModal.keywordsPlaceholder": "price\nsize\ncatalog",
  "intentModal.handlerType": "Handler Type",
  "intentModal.handlerAiGenerate": "AI generates response",
  "intentModal.handlerAutoReply": "Automatic reply",
  "intentModal.handlerFlow": "Conversational flow",
  "intentModal.handlerHandoff": "Transfer to human",
  "intentModal.aiPrompt": "AI Prompt",
  "intentModal.aiPromptPlaceholder": "The user is asking about product prices. Provide pricing info based on the active campaign...",
  "intentModal.autoReplyMessage": "Automatic Reply Message",
  "intentModal.autoReplyPlaceholder": "Thanks for your interest! A sales rep will contact you shortly.",
  "intentModal.flowToTrigger": "Flow to Trigger",
  "intentModal.selectFlow": "Select flow...",
  "intentModal.handoffReason": "Handoff Reason",
  "intentModal.handoffPlaceholder": "Interested in being a distributor",
  "intentModal.responseLanguage": "Response Language",
  "intentModal.maxTokens": "Max Tokens",
  "intentModal.statsTitle": "Statistics",
  "intentModal.triggerCount": "Trigger Count",
  "intentModal.lastTriggered": "Last Triggered",
  "intentModal.never": "Never",
  "intentModal.createdAt": "Created",
  "intentModal.updatedAt": "Updated",
  "intentModal.save": "Save Changes",
  "intentModal.cancel": "Cancel",
  "intentModal.errorKeyName": "Please fill in the key and name",
  "intentModal.handlerAiGenerateDesc": "The bot uses AI to generate a contextual response",
  "intentModal.handlerAutoResponse": "Automatic reply",
  "intentModal.handlerAutoResponseDesc": "Uses the defined response template",
  "intentModal.handlerFlowDesc": "Starts a specific conversational flow",
  "intentModal.handlerHumanHandoff": "Transfer to human",
  "intentModal.handlerHumanHandoffDesc": "Transfers the conversation to a human agent",
  "intentModal.keyHint": "Unique identifier (lowercase and _)",
  "intentModal.nameRequired": "Name *",
  "intentModal.descPlaceholder": "Describe when this intent is triggered (used by AI for classification)",
  "intentModal.intentActive": "Intent active",
  "intentModal.intentActiveHint": "Only active intents are used by the classifier",
  "intentModal.priorityHint": "Higher priority = considered first when multiple intents may match",
  "intentModal.keywordsLabel": "Keywords",
  "intentModal.keywordPlaceholder": "Type a keyword and press Enter",
  "intentModal.regexPatterns": "Regex Patterns (Advanced)",
  "intentModal.regexHint": "Optional regex patterns for fast detection without AI",
  "intentModal.responseType": "Response type",
  "intentModal.flowToExecute": "Flow to execute",
  "intentModal.noFlows": "No flows created. Go to the Flows section to create one.",
  "intentModal.flowLinked": "This intent will start the selected flow when detected.",
  "intentModal.responseTemplate": "Response template",
  "intentModal.responseTemplatePlaceholder": "Default response when this intent is detected (used by auto_response)",
  "intentModal.responseAutoHint": "This response will be sent automatically when the intent is detected",
  "intentModal.responseFlowHint": "Optional: welcome message before starting the flow",
  "intentModal.responseAiHint": "Optional: can be used as context for the AI",
  "intentModal.timesDetected": "Times detected",
  "intentModal.lastDetection": "Last detection",
  "intentModal.created": "Created",
  "intentModal.lastModified": "Last modified",
  "intentModal.saveChanges": "Save Changes",
  "intentModal.createIntent": "Create Intent",
  "intentModal.validationRequired": "Please fill in the key and name",
  "intentModal.validationKeyFormat": "Key can only contain lowercase letters, numbers and underscores, and must start with a letter",
  "intentModal.invalidRegex": "Invalid regex pattern: ",

  // ── intentsView ──
  "intentsView.title": "Intent Management",
  "intentsView.newCategory": "New Category",
  "intentsView.newIntent": "New Intent",
  "intentsView.tabIntents": "Intents",
  "intentsView.tabCategories": "Categories",
  "intentsView.filterActive": "Active",
  "intentsView.filterInactive": "Inactive",
  "intentsView.filterAll": "All statuses",
  "intentsView.active": "Active",
  "intentsView.inactive": "Inactive",
  "intentsView.confirmDeleteIntent": "Are you sure you want to delete this intent?",
  "intentsView.intentUpdated": "Intent updated successfully",
  "intentsView.intentCreated": "Intent created successfully",
  "intentsView.errorLoadIntents": "Error loading intents",
  "intentsView.intentDeleted": "Intent deleted successfully",
  "intentsView.key": "Key",
  "intentsView.name": "Name",
  "intentsView.category": "Category",
  "intentsView.handler": "Handler",
  "intentsView.priority": "Priority",
  "intentsView.status": "Status",
  "intentsView.actions": "Actions",
  "intentsView.noIntents": "No intents found",
  "intentsView.loading": "Loading intents...",
  "intentsView.triggers": "triggers",
  "intentsView.searchPlaceholder": "Search intents...",
  "intentsView.low": "Low",
  "intentsView.high": "High",
  "intentsView.confirmDeleteCategory": "Are you sure you want to delete this category?",
  "intentsView.categoryCreated": "Category created successfully",
  "intentsView.categoryUpdated": "Category updated successfully",
  "intentsView.categoryDeleted": "Category deleted successfully",
  "intentsView.errorLoadCategories": "Error loading categories",
  "intentsView.noCategories": "No categories found",
  "intentsView.description": "Description",
  "intentsView.intentsCount": "Intents",
  "intentsView.color": "Color",
  "intentsView.uncategorized": "Uncategorized",
  "intentsView.errorDeleteIntent": "Error deleting intent",
  "intentsView.errorDeleteCategory": "Error deleting category",
  "intentsView.errorSaveIntent": "Error saving intent",
  "intentsView.errorSaveCategory": "Error saving category",
  "intentsView.noCategoryLabel": "No category",
  "intentsView.subtitle": "Configure the intents the bot can detect",
  "intentsView.intentsTab": "Intents",
  "intentsView.categoriesTab": "Categories",
  "intentsView.allCategories": "All categories",
  "intentsView.allStatuses": "All statuses",
  "intentsView.statusActive": "Active",
  "intentsView.statusInactive": "Inactive",
  "intentsView.totalIntents": "Total Intents",
  "intentsView.categories": "Categories",
  "intentsView.totalHits": "Total Hits",
  "intentsView.loadingIntents": "Loading intents...",
  "intentsView.noResults": "No results",
  "intentsView.createFirst": "Create the first system intent",
  "intentsView.tryOtherFilters": "Try different search filters",
  "intentsView.more": "+{{count}} more",
  "intentsView.intentActivated": "Intent activated",
  "intentsView.intentDeactivated": "Intent deactivated",
  "intentsView.errorToggle": "Error changing status",
  "intentsView.createFirstCategory": "Create the first category",
  "intentsView.handlerAutoResponse": "Automatic reply",
  "intentsView.handlerFlow": "Flow",
  "intentsView.handlerHumanHandoff": "Transfer to human",
  "intentsView.handlerAiGenerate": "AI generates response",

  // ── masterCatalog ──
  "masterCatalog.subtitle": "Manage base product information entries",
  "masterCatalog.newEntry": "New Entry",
  "masterCatalog.listTitle": "Master Catalog Entries",
  "masterCatalog.loading": "Loading catalog...",
  "masterCatalog.composition": "Composition",
  "masterCatalog.emptyDescription": "Start by adding your first master catalog entry",
  "masterCatalog.addEntryButton": "Add Entry",
  "masterCatalog.headerName": "Name",
  "masterCatalog.headerDescription": "Description",
  "masterCatalog.headerComposition": "Composition",

  // ── masterCatalogModal ──
  "masterCatalogModal.editTitle": "Edit Entry",
  "masterCatalogModal.newTitle": "New Entry",
  "masterCatalogModal.descriptionPlaceholder": "Product subfamily description...",
  "masterCatalogModal.compositionLabel": "Composition",
  "masterCatalogModal.nameRequired": "Name *",
  "masterCatalogModal.description": "Description",
  "masterCatalogModal.composition": "Composition",
  "masterCatalogModal.update": "Update",

  // ── permissions ──
  "permissions.all": "All permissions (*)",
  "permissions.conversations": "Conversations",
  "permissions.campaigns": "Campaigns",
  "permissions.adsets": "Ad Sets",
  "permissions.ads": "Ads",
  "permissions.products": "Products",
  "permissions.analytics": "Analytics",
  "permissions.families": "Families",
  "permissions.masterCatalog": "Master Catalog",
  "permissions.usos": "Uses",
  "permissions.inventario": "Inventory",
  "permissions.users": "Users",
  "permissions.allPermissions": "All permissions (*)",

  // ── posModal ──
  "posModal.editTitle": "Edit Point of Sale",
  "posModal.newTitle": "New Point of Sale",
  "posModal.nameRequired": "Name *",
  "posModal.namePlaceholder": "Downtown Store",
  "posModal.descriptionLabel": "Description",
  "posModal.descriptionPlaceholder": "Brief description of the point of sale",
  "posModal.addressLabel": "Address",
  "posModal.phoneLabel": "Phone",
  "posModal.emailLabel": "Email",
  "posModal.activeCheckbox": "Active",
  "posModal.cancel": "Cancel",
  "posModal.update": "Update",
  "posModal.errorRequired": "Please fill in the name",
  "posModal.infoTitle": "Point of Sale Info",
  "posModal.baseUrl": "Base URL",
  "posModal.baseUrlHint": "Optional base URL to be used by default (e.g.: https://mercadolibre.com.mx/)",
  "posModal.icon": "Icon / Emoji",
  "posModal.iconHint": "Emoji or image URL representing the store",
  "posModal.description": "Description",
  "posModal.saveChanges": "Save Changes",
  "posModal.createPOS": "Create Point of Sale",

  // ── productDetails ──
  "productDetails.basicInfo": "Basic Info",
  "productDetails.dimensions": "Dimensions",
  "productDetails.sellableInfo": "Sellable Info",
  "productDetails.storeLinks": "Store Links",
  "productDetails.close": "Close",
  "productDetails.name": "Name",
  "productDetails.description": "Description",
  "productDetails.generation": "Generation",
  "productDetails.sellable": "Sellable",
  "productDetails.yes": "Yes",
  "productDetails.no": "No",
  "productDetails.parent": "Parent",
  "productDetails.sku": "SKU",
  "productDetails.stock": "Inventory",
  "productDetails.price": "Price",
  "productDetails.wholesaleEnabled": "Wholesale",
  "productDetails.minQuantity": "Min Quantity",
  "productDetails.wholesalePrice": "Wholesale Price",
  "productDetails.primary": "Primary",
  "productDetails.store": "Store",
  "productDetails.url": "URL",
  "productDetails.noLinks": "No store links",
  "productDetails.noDimensions": "No dimensions configured",
  "productDetails.noDescription": "No description",
  "productDetails.path": "Path",
  "productDetails.createdAt": "Created",
  "productDetails.updatedAt": "Updated",
  "productDetails.requiresAdvisor": "Requires Advisor",
  "productDetails.catalog": "Catalog",
  "productDetails.specifications": "Specifications",
  "productDetails.marketing": "Marketing",
  "productDetails.children": "Children",
  "productDetails.childrenCount": "{{count}} child products",
  "productDetails.status": "Status",
  "productDetails.notSellable": "Not Sellable",
  "productDetails.parentProduct": "Parent Product",
  "productDetails.priceInherited": "(inherited)",
  "productDetails.priceApply": "This price can be applied to all descendant sellable products",
  "productDetails.priceInheritedHint": "This price is inherited from a parent product in the hierarchy",
  "productDetails.salesInfo": "Sales Info",
  "productDetails.inventory": "Inventory",
  "productDetails.units": "units",
  "productDetails.availability": "Availability",
  "productDetails.available": "Available",
  "productDetails.notAvailable": "Not Available",
  "productDetails.active": "Active",
  "productDetails.inactive": "Inactive",
  "productDetails.requiresHumanAdvisor": "Requires human advisor",
  "productDetails.marketingDescription": "Marketing Description",
  "productDetails.genericDescription": "Generic Description (Cross-Selling)",
  "productDetails.onlineStoreLinks": "Online Store Links",
  "productDetails.onlineStore": "Online Store",
  "productDetails.image": "Image",
  "productDetails.imageUnavailable": "Image unavailable",
  "productDetails.dimensionsAvailable": "Available Dimensions",
  "productDetails.dimensionValues": "Dimension Values",
  "productDetails.ownDimensions": "Own dimensions are in purple, inherited in amber",
  "productDetails.allInherited": "All these dimensions are inherited from parent products",
  "productDetails.childrenCountPlural": "This product has {{count}} children",
  "productDetails.inheritedLabel": "inherited",

  // ── productModal ──
  "productModal.editTitle": "Edit Product",
  "productModal.newTitle": "New Product",
  "productModal.nameRequired": "Name *",
  "productModal.typeLabel": "Type",
  "productModal.typeConfeccionada": "Pre-made",
  "productModal.typeRollo": "Roll",
  "productModal.sizeLabel": "Size",
  "productModal.priceLabel": "Price",
  "productModal.mlLinkLabel": "Mercado Libre Link",
  "productModal.imageUrl": "Image URL",
  "productModal.descriptionLabel": "Description",
  "productModal.descriptionPlaceholder": "Product description...",
  "productModal.wholesaleEnabled": "Wholesale enabled",
  "productModal.minQuantity": "Min Quantity",
  "productModal.wholesalePrice": "Wholesale Price",
  "productModal.cancel": "Cancel",
  "productModal.create": "Create Product",
  "productModal.update": "Update Product",
  "productModal.typeRequired": "Type *",
  "productModal.size": "Size",
  "productModal.price": "Price",
  "productModal.wholesaleMinQty": "Minimum quantity",
  "productModal.mlLink": "Mercado Libre Link",
  "productModal.description": "Description",
  "productModal.updateProduct": "Update Product",
  "productModal.createProduct": "Create Product",

  // ── productTreeSelector ──
  "productTreeSelector.loading": "Loading products...",
  "productTreeSelector.noProducts": "No products found",
  "productTreeSelector.expand": "Expand",
  "productTreeSelector.collapse": "Collapse",
  "productTreeSelector.sellable": "Sellable",
  "productTreeSelector.gen": "Gen",
  "productTreeSelector.selectedCount": "{{count}} selected",
  "productTreeSelector.noSellable": "No sellable products found",
  "productTreeSelector.apply": "Apply",
  "productTreeSelector.cancel": "Cancel",
  "productTreeSelector.selectProducts": "Select products",
  "productTreeSelector.clearSelection": "Clear selection",
  "productTreeSelector.searchResults": "Search results",
  "productTreeSelector.searchProducts": "Search products...",
  "productTreeSelector.collapseAll": "Collapse all",
  "productTreeSelector.expandAll": "Expand all",
  "productTreeSelector.loadingProducts": "Loading products...",
  "productTreeSelector.noProductsFound": "No products found",
  "productTreeSelector.noProductsAvailable": "No products available",
  "productTreeSelector.inherited": "Inherited",
  "productTreeSelector.notAvailable": "Not available",
  "productTreeSelector.selectedSpecific": "{{count}} product selected (specific)",
  "productTreeSelector.selectedSpecificPlural": "{{count}} products selected (specific)",
  "productTreeSelector.inheritedProducts": "{{count}} inherited product",
  "productTreeSelector.inheritedProductsPlural": "{{count}} inherited products",
  "productTreeSelector.from": "from",
  "productTreeSelector.noSelection": "No products selected",
  "productTreeSelector.overriding": "(Overriding {{count}} inherited product from {{from}})",
  "productTreeSelector.overridingPlural": "(Overriding {{count}} inherited products from {{from}})",

  // ── products ──
  "products.subtitle": "Manage product catalog",
  "products.listTitle": "Product List",
  "products.loadingProducts": "Loading products...",
  "products.name": "Name",
  "products.type": "Type",
  "products.size": "Size",
  "products.mlLink": "ML Link",
  "products.actions": "Actions",
  "products.view": "View",
  "products.errorLoad": "Error loading products",
  "products.errorSave": "Error saving product",
  "products.errorDelete": "Error deleting product",
  "products.savedSuccess": "Product saved successfully",
  "products.deletedSuccess": "Product deleted successfully",
  "products.startAdding": "Start by adding your first product",
  "products.addProductButton": "Add Product",
  "products.thName": "Name",
  "products.thType": "Type",
  "products.thSize": "Size",
  "products.thPrice": "Price",
  "products.thMLLink": "ML Link",
  "products.thActions": "Actions",
  "products.editTooltip": "Edit",
  "products.deleteTooltip": "Delete",

  // ── profileModal ──
  "profileModal.editTitle": "Edit Profile",
  "profileModal.newTitle": "New Profile",
  "profileModal.roleLabel": "Role *",
  "profileModal.noRolesAvailable": "No roles available that allow profiles...",
  "profileModal.nameLabel": "Name (identifier) *",
  "profileModal.labelLabel": "Label (display) *",
  "profileModal.descriptionLabel": "Description",
  "profileModal.descriptionPlaceholder": "Brief description of the profile and its responsibilities",
  "profileModal.permissionsTitle": "Permissions",
  "profileModal.activeCheckbox": "Active profile",
  "profileModal.activeHint": "Inactive profiles cannot be assigned to new users",
  "profileModal.systemTitle": "System Profile",
  "profileModal.systemWarning": "This is a system profile. The name and role cannot be modified.",
  "profileModal.errorRequired": "Please fill in the name, label and select a role",
  "profileModal.errorRoleNoProfiles": "The selected role does not allow profiles",
  "profileModal.roleRequired": "Role *",
  "profileModal.selectRoleOption": "Select role...",
  "profileModal.nameIdentifier": "Name (identifier) *",
  "profileModal.nameHelp": "Lowercase letters and underscores only",
  "profileModal.labelDisplay": "Label (display) *",
  "profileModal.description": "Description",
  "profileModal.profileActive": "Active profile",
  "profileModal.profileActiveHelp": "Inactive profiles cannot be assigned to new users",
  "profileModal.systemProfile": "System Profile",
  "profileModal.systemProfileHelp": "This is a system profile. The name and role cannot be modified.",
  "profileModal.saveChanges": "Save Changes",
  "profileModal.createProfile": "Create Profile",
  "profileModal.errorFields": "Please fill in the name, label and select a role",
  "profileModal.errorNameFormat": "Name can only contain lowercase letters and underscores",
  "profileModal.landingPage": "Landing Page",
  "profileModal.landingPageDefault": "Default (home /)",
  "profileModal.landingPageHelp": "Page users with this profile see after logging in. Only routes they have permission to access are shown.",

  // ── profiles ──
  "profiles.newProfile": "New Profile",
  "profiles.loading": "Loading profiles...",
  "profiles.permissions": "Permissions",
  "profiles.status": "Status",
  "profiles.actions": "Actions",
  "profiles.active": "Active",
  "profiles.inactive": "Inactive",
  "profiles.system": "System",
  "profiles.confirmDelete": "Are you sure you want to delete this profile?",
  "profiles.errorDelete": "Error deleting profile",
  "profiles.deletedSuccess": "Profile deleted successfully",
  "profiles.errorLoad": "Error loading profiles",
  "profiles.errorSave": "Error saving profile",
  "profiles.createdSuccess": "Profile created successfully",
  "profiles.titleFull": "Profile Management",
  "profiles.subtitle": "Manage profiles within each role",
  "profiles.emptyDescription": "Create the first system profile",
  "profiles.noRole": "No Role",
  "profiles.profileCount": "profile",
  "profiles.profilesCount": "profiles",
  "profiles.permissionsLabel": "Permissions:",
  "profiles.allPermissions": "All (*)",
  "profiles.noPermissions": "No permissions",
  "profiles.createdByLabel": "Created by:",
  "profiles.landingPage": "Landing:",
  "profiles.updatedSuccess": "Profile updated successfully",

  // ── purchaseIntent ──
  "purchaseIntent.subtitle": "AI-detected purchase intent signals",
  "purchaseIntent.loading": "Loading...",
  "purchaseIntent.noData": "No purchase intent data",
  "purchaseIntent.score": "Score",
  "purchaseIntent.high": "High",
  "purchaseIntent.medium": "Medium",
  "purchaseIntent.low": "Low",
  "purchaseIntent.signals": "Signals",
  "purchaseIntent.product": "Product",
  "purchaseIntent.confidence": "Confidence",
  "purchaseIntent.timestamp": "Timestamp",
  "purchaseIntent.user": "User",
  "purchaseIntent.titleLabel": "Purchase Intent",
  "purchaseIntent.refresh": "Refresh",
  "purchaseIntent.highDesc": "Ready to buy",
  "purchaseIntent.mediumDesc": "Exploring options",
  "purchaseIntent.lowDesc": "Curious / Competition",
  "purchaseIntent.totalWithScore": "Total with score: {{count}} conversations",
  "purchaseIntent.leadsLabel": "{{label}} Intent Leads",
  "purchaseIntent.loadingLeads": "Loading...",
  "purchaseIntent.noConversations": "No conversations with this intent",

  // ── roleModal ──
  "roleModal.editTitle": "Edit Role",
  "roleModal.newTitle": "New Role",
  "roleModal.nameLabel": "Name (identifier) *",
  "roleModal.nameHint": "Lowercase letters and underscores only",
  "roleModal.labelLabel": "Label (display) *",
  "roleModal.descriptionLabel": "Description",
  "roleModal.permissionsTitle": "Permissions",
  "roleModal.allowsProfiles": "Allows profiles",
  "roleModal.allowsProfilesHint": "Users with this role can have specific profiles",
  "roleModal.activeCheckbox": "Active role",
  "roleModal.activeHint": "Inactive roles cannot be assigned to new users",
  "roleModal.systemTitle": "System Role",
  "roleModal.systemWarning": "This is a system role. The name cannot be modified.",
  "roleModal.errorNameLabel": "Please fill in the name and label",
  "roleModal.errorNameFormat": "Name can only contain lowercase letters and underscores",
  "roleModal.nameIdentifier": "Name (identifier) *",
  "roleModal.nameHelp": "Lowercase letters and underscores only",
  "roleModal.labelDisplay": "Label (display) *",
  "roleModal.description": "Description",
  "roleModal.allowsProfilesHelp": "Users with this role can have specific profiles",
  "roleModal.roleActive": "Active role",
  "roleModal.roleActiveHelp": "Inactive roles cannot be assigned to new users",
  "roleModal.systemRole": "System Role",
  "roleModal.systemRoleHelp": "This is a system role. The name cannot be modified.",
  "roleModal.saveChanges": "Save Changes",
  "roleModal.createRole": "Create Role",

  // ── roles ──
  "roles.subtitle": "Manage roles, profiles and their permissions",
  "roles.tabRoles": "Roles",
  "roles.tabProfiles": "Profiles",
  "roles.newRole": "New Role",
  "roles.loading": "Loading roles...",
  "roles.status": "Status",
  "roles.actions": "Actions",
  "roles.active": "Active",
  "roles.inactive": "Inactive",
  "roles.system": "System",
  "roles.confirmDelete": "Are you sure you want to delete this role?",
  "roles.errorDelete": "Error deleting role",
  "roles.deletedSuccess": "Role deleted successfully",
  "roles.titleFull": "Role Management",
  "roles.emptyDescription": "Create the first system role",
  "roles.permissionsLabel": "Permissions:",
  "roles.allPermissions": "All (*)",
  "roles.noPermissions": "No permissions",
  "roles.allowsProfilesLabel": "Allows profiles:",
  "roles.createdByLabel": "Created by:",
  "roles.updatedSuccess": "Role updated successfully",
  "roles.createdSuccess": "Role created successfully",
  "roles.errorSave": "Error saving role",
  "roles.errorLoad": "Error loading roles",

  // ── simulationSelector ──
  "simulationSelector.subtitle": "View the dashboard as a different role",
  "simulationSelector.active": "Simulating: {{label}}",
  "simulationSelector.noRoles": "No roles available",
  "simulationSelector.noProfiles": "No profiles for this role",
  "simulationSelector.description": "As super admin, you can simulate how the dashboard looks for different roles and profiles",
  "simulationSelector.warning": "Simulation mode only affects navigation and visibility. Actions still use your real permissions.",
  "simulationSelector.currentlySimulating": "Currently simulating",
  "simulationSelector.viewAs": "View as...",
  "simulationSelector.viewLabel": "View: {{label}}",
  "simulationSelector.dropdownTitle": "Simulate Access Level",
  "simulationSelector.dropdownDesc": "See the dashboard as another user would",
  "simulationSelector.loadingRoles": "Loading roles...",
  "simulationSelector.exitSimulation": "Exit simulation",
  "simulationSelector.allPermissions": "(All permissions)",
  "simulationSelector.fullAccess": "Full access",
  "simulationSelector.permissionsCount": "{{count}} permissions",
  "simulationSelector.activeLabel": "Active",
  "simulationSelector.accessLevel": "Simulate access level",

  // ── trackedLink ──
  "trackedLink.selectProduct": "Select Product",
  "trackedLink.searchProducts": "Search products...",
  "trackedLink.loading": "Loading...",
  "trackedLink.noProducts": "No products found",
  "trackedLink.selectedProduct": "Selected Product",
  "trackedLink.generateLink": "Generate Link",
  "trackedLink.generating": "Generating...",
  "trackedLink.copyLink": "Copy Link",
  "trackedLink.generateTitle": "Generate Tracked Link",
  "trackedLink.searchProduct": "Search product...",
  "trackedLink.loadingProducts": "Loading...",
  "trackedLink.generateBtn": "Generate Tracked Link",
  "trackedLink.copiedBtn": "Copied!",
  "trackedLink.copyBtn": "Copy",
  "trackedLink.pasteHint": "Paste this link in the conversation with the customer",
  "trackedLink.errorLoad": "Error loading products",
  "trackedLink.errorGenerate": "Error generating link",
  "trackedLink.modeProduct": "Pick Product",
  "trackedLink.modeCustom": "Custom URL",
  "trackedLink.customUrlPlaceholder": "https://articulo.mercadolibre.com.mx/...",
  "trackedLink.customNamePlaceholder": "Product name (optional)",
  "trackedLink.customNameHint": "Optional — helps identify this link in reports",
  "trackedLink.customDefault": "Custom link",

  // ── userModal ──
  "userModal.editTitle": "Edit User",
  "userModal.newTitle": "New User",
  "userModal.usernameLabel": "Username *",
  "userModal.fullNameLabel": "Full Name",
  "userModal.fullNamePlaceholder": "John Doe",
  "userModal.emailLabel": "Email",
  "userModal.passwordLabel": "Password *",
  "userModal.roleLabel": "Role *",
  "userModal.profileLabel": "Profile",
  "userModal.noProfiles": "No profiles for this role",
  "userModal.activeCheckbox": "Active",
  "userModal.cancel": "Cancel",
  "userModal.update": "Update User",
  "userModal.errorRequired": "Please fill in username, password and role",
  "userModal.firstNameRequired": "First Name *",
  "userModal.lastNameRequired": "Last Name *",
  "userModal.usernameRequired": "Username *",
  "userModal.usernameCannotChange": "Username cannot be changed",
  "userModal.emailRequired": "Email *",
  "userModal.passwordEditHint": "Leave blank to keep current password",
  "userModal.passwordPlaceholderEdit": "Leave blank to keep unchanged",
  "userModal.roleRequired": "Role *",
  "userModal.loadingRoles": "Loading roles...",
  "userModal.profileRequired": "Profile *",
  "userModal.updateUser": "Update User",
  "userModal.createUser": "Create User",
  "userModal.alertRequired": "Please fill in all required fields",
  "userModal.alertPasswordRequired": "Password is required for new users",
  "userModal.alertProfileRequired": "Profile is required for this role",

  // ── users ──
  "users.newUser": "New User",
  "users.loading": "Loading users...",
  "users.status": "Status",
  "users.actions": "Actions",
  "users.active": "Active",
  "users.inactive": "Inactive",
  "users.confirmDelete": "Are you sure you want to delete this user?",
  "users.userCreated": "User created successfully",
  "users.userUpdated": "User updated successfully",
  "users.userDeleted": "User deleted successfully",
  "users.errorLoad": "Error loading users",
  "users.errorSave": "Error saving user",
  "users.errorDelete": "Error deleting user",
  "users.resetPassword": "Reset Password",
  "users.dashboardTitle": "Dashboard Users",
  "users.loadingUsers": "Loading users...",
  "users.noUsersDesc": "Create the first system user",
  "users.thUser": "User",
  "users.thRole": "Role",
  "users.thProfile": "Profile",
  "users.thStatus": "Status",
  "users.thLastAccess": "Last access",
  "users.thActions": "Actions",
  "users.activeStatus": "Active",
  "users.inactiveStatus": "Inactive",
  "users.never": "Never",
  "users.noPermissions": "No permissions",
  "users.editTooltip": "Edit",
  "users.deleteTooltip": "Delete",
  "users.updatedSuccess": "User updated successfully",
  "users.createdSuccess": "User created successfully",
  "users.deletedSuccess": "User deleted successfully",

  // ── usos ──
  "usos.subtitle": "Manage product uses and applications",
  "usos.newUso": "New Use",
  "usos.loading": "Loading uses...",
  "usos.noUsosRegistered": "No uses registered",
  "usos.startAdding": "Start by adding the first use",
  "usos.thName": "Name",
  "usos.thDescription": "Description",
  "usos.thActions": "Actions",
  "usos.products": "Products",
  "usos.status": "Status",
  "usos.actions": "Actions",
  "usos.active": "Active",
  "usos.inactive": "Inactive",
  "usos.confirmDelete": "Are you sure you want to delete this use?",
  "usos.deletedSuccess": "Use deleted successfully",
  "usos.listTitle": "Uses List",
  "usos.loadingUsos": "Loading uses...",
  "usos.inactiveLabel": "Inactive",
  "usos.productsCount": "{{count}} product",
  "usos.productsCountPlural": "{{count}} products",
  "usos.notFound": "{{count}} product not found",
  "usos.notFoundPlural": "{{count}} products not found",
  "usos.more": "+{{count}} more",
  "usos.editTooltip": "Edit",
  "usos.deleteTooltip": "Delete",

  // ── usosGrupos ──
  "usosGrupos.tabUsos": "Uses",
  "usosGrupos.tabGrupos": "Groups",
  "usosGrupos.subtitle": "Manage product uses and groups to improve recommendations and organization",
  "usosGrupos.usosTabLabel": "Uses",
  "usosGrupos.gruposTabLabel": "Groups",

  // ── usosModal ──
  "usosModal.editTitle": "Edit Use",
  "usosModal.newTitle": "New Use",
  "usosModal.nameRequired": "Name *",
  "usosModal.namePlaceholder": "Agriculture",
  "usosModal.descriptionLabel": "Description",
  "usosModal.descriptionPlaceholder": "Description of the product use or application...",
  "usosModal.associatedProducts": "Associated Products",
  "usosModal.addProduct": "Add Product",
  "usosModal.removeProduct": "Remove",
  "usosModal.selectProduct": "Select product...",
  "usosModal.noProducts": "No products added",
  "usosModal.activeCheckbox": "Active",
  "usosModal.cancel": "Cancel",
  "usosModal.update": "Update Use",
  "usosModal.errorRequired": "Please fill in the name",
  "usosModal.errorSave": "Error saving use",
  "usosModal.savedSuccess": "Use saved successfully",
  "usosModal.basicInfo": "Basic Info",
  "usosModal.description": "Description",
  "usosModal.keywords": "Keywords",
  "usosModal.keywordsHint": "Separated by comma. The bot will detect these words to suggest products.",
  "usosModal.imageUrl": "Image URL",
  "usosModal.priorityLabel": "Priority: {{value}}",
  "usosModal.priorityLow": "Low (1)",
  "usosModal.priorityHigh": "High (10)",
  "usosModal.available": "Use available",
  "usosModal.productsHint": "Select products associated with this use. You can expand categories to see specific products.",
  "usosModal.updateUso": "Update Use",
  "usosModal.createUso": "Create Use",

  // ── Menu: Manual Sales ──
  "menu.manualSales": "Manual Sales",

  // ── Messages: Register Sale button ──
  "messages.registerSale": "Register Sale",
  "messages.closeSale": "Close Sale",

  // ── Manual Sale Form ──
  "manualSale.title": "Register Sale",
  "manualSale.product": "Product",
  "manualSale.productPlaceholder": "Product name...",
  "manualSale.amount": "Sale Amount",
  "manualSale.notes": "Notes (optional)",
  "manualSale.notesPlaceholder": "Additional details about this sale...",
  "manualSale.register": "Register Sale",
  "manualSale.registering": "Registering...",
  "manualSale.success": "Sale registered!",
  "manualSale.error": "Error registering sale",

  // ── Manual Sales View ──
  "manualSales.title": "Manual Sales",
  "manualSales.totalSales": "Total Sales",
  "manualSales.totalRevenue": "Total Revenue",
  "manualSales.thisMonth": "This Month",
  "manualSales.from": "From:",
  "manualSales.to": "To:",
  "manualSales.clearFilter": "Clear",
  "manualSales.noSales": "No manual sales registered",
  "manualSales.colDate": "Date",
  "manualSales.colCustomer": "Customer",
  "manualSales.colProduct": "Product",
  "manualSales.colAmount": "Amount",
  "manualSales.colCampaign": "Campaign",
  "manualSales.colNotes": "Notes",

  // ── Home / Executive Dashboard ─────────────────────────
  "home.pageTitle": "Executive Dashboard",
  "home.totalRevenue": "Total Revenue",
  "home.totalConversions": "Total Conversions",
  "home.activeConversations": "Active Conversations",
  "home.conversionRate": "Conversion Rate",
  "home.revenueOverTime": "Daily Data",
  "home.clicks": "Clicks",
  "home.conversions": "Conversions",
  "home.linksGenerated": "Links Generated",
  "home.topProducts": "Top Products",
  "home.byRevenue": "by revenue",
  "home.salesFunnel": "Sales Funnel",
  "home.funnelLinks": "Links",
  "home.funnelClicks": "Clicks",
  "home.funnelConversions": "Conversions",
  "home.funnelRevenue": "Revenue",
  "home.geoDistribution": "Geographic Distribution",
  "home.byConversations": "by conversations",
  "home.confidenceBreakdown": "Attribution Confidence",
  "home.high": "High",
  "home.medium": "Medium",
  "home.low": "Low",
  "home.adPerformance": "Ad Performance",
  "home.adName": "Ad Name",
  "home.adClicks": "Clicks",
  "home.adConversions": "Conversions",
  "home.convRate": "Conv Rate",
  "home.last7d": "7d",
  "home.last15d": "15d",
  "home.last30d": "30d",
  "home.last90d": "90d",
  "home.noData": "No data available",
  "home.loadingDashboard": "Loading dashboard...",
  "home.conversations": "conversations",
  "home.cities": "cities",
  "home.uniqueUsers": "Unique Users",
  "home.totalMessages": "Total Messages",
  "home.botResponseRate": "Response Rate",
  "home.unanswered": "Unanswered",
  "home.topRegion": "Top Region",
  "home.byClicks": "by clicks",
  "home.clickRate": "Click Rate",
  "home.aboveBenchmark": "Above average",
  "home.atBenchmark": "At average",
  "home.belowBenchmark": "Below average",

  // ── Conversions (additional charts) ────────────────────
  "conversions.confidenceChart": "Attribution Confidence",
  "conversions.topProductsChart": "Top Products by Revenue",

  // ── Tickets ─────────────────────────────────────────────
  "tickets.title": "Tickets",
  "tickets.new": "New ticket",
  "tickets.create": "Create ticket",
  "tickets.titleField": "Title",
  "tickets.titlePlaceholder": "Briefly describe the issue...",
  "tickets.descriptionPlaceholder": "Ticket details...",
  "tickets.priority": "Priority",
  "tickets.assignedTo": "Assigned to",
  "tickets.assignTo": "Assign to",
  "tickets.comments": "comments",
  "tickets.commentPlaceholder": "Write a comment...",
  "tickets.send": "Send",
  "tickets.empty": "No tickets",
  "tickets.creatorHint": "You can edit the title and description of your tickets.",

  // ── Notifications ───────────────────────────────────────
  "notifications.title": "Notifications",
  "notifications.new": "New notification",
  "notifications.titlePlaceholder": "Notification title...",
  "notifications.message": "Message",
  "notifications.messagePlaceholder": "Notification content...",
  "notifications.global": "Global",
  "notifications.individual": "Individual",
  "notifications.targetUser": "Target user",
  "notifications.selectUser": "Select a user...",
  "notifications.send": "Send notification",
  "notifications.markAllRead": "Mark all as read",
  "notifications.empty": "No notifications",
  "notifications.sentTo": "Sent to",

  // ── Cross-Selling ───────────────────────────────────────
  "crossSell.title": "Cross-Selling",
  "crossSell.description": "Configure cross-selling rules to automatically suggest complementary products to your customers during conversations or after a purchase.",
  "crossSell.comingSoon": "Coming Soon",
};

export default en;
